/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { withoutUndefinedValues } from "@pagopa/ts-commons/lib/types";
import {
  RequestParams,
  TypeofApiCall,
  TypeofApiParams,
  createFetchRequestForApi,
  ReplaceRequestParams
} from "@pagopa/ts-commons/lib/requests";
import { identity } from "fp-ts/lib/function";

import {
  ManageCIStationRelationshipT,
  manageCIStationRelationshipDefaultDecoder,
  MassiveMigrationT,
  massiveMigrationDefaultDecoder,
  GetBrokersT,
  getBrokersDefaultDecoder,
  CreateBrokerT,
  createBrokerDefaultDecoder,
  GetAllStationsMaintenancesT,
  getAllStationsMaintenancesDefaultDecoder,
  DeleteBrokerT,
  deleteBrokerDefaultDecoder,
  GetBrokerT,
  getBrokerDefaultDecoder,
  UpdateBrokerT,
  updateBrokerDefaultDecoder,
  GetStationMaintenancesT,
  getStationMaintenancesDefaultDecoder,
  CreateStationMaintenanceT,
  createStationMaintenanceDefaultDecoder,
  GetBrokerMaintenancesSummaryT,
  getBrokerMaintenancesSummaryDefaultDecoder,
  DeleteStationMaintenanceT,
  deleteStationMaintenanceDefaultDecoder,
  GetStationMaintenanceT,
  getStationMaintenanceDefaultDecoder,
  UpdateStationMaintenanceT,
  updateStationMaintenanceDefaultDecoder,
  GetBrokersPspT,
  getBrokersPspDefaultDecoder,
  CreateBrokerPspT,
  createBrokerPspDefaultDecoder,
  DeleteBrokerPspT,
  deleteBrokerPspDefaultDecoder,
  GetBrokerPspT,
  getBrokerPspDefaultDecoder,
  UpdateBrokerPspT,
  updateBrokerPspDefaultDecoder,
  GetPspBrokerPspT,
  getPspBrokerPspDefaultDecoder,
  GetCacheVersionsT,
  getCacheVersionsDefaultDecoder,
  GetCacheByVersionT,
  getCacheByVersionDefaultDecoder,
  GetCacheIdT,
  getCacheIdDefaultDecoder,
  GetCdisT,
  getCdisDefaultDecoder,
  CreateCdiT,
  createCdiDefaultDecoder,
  VerifyCdiT,
  verifyCdiDefaultDecoder,
  UploadHistory_1T,
  uploadHistory_1DefaultDecoder,
  DeleteCdiT,
  deleteCdiDefaultDecoder,
  GetCdiT,
  getCdiDefaultDecoder,
  GetCdsServicesT,
  getCdsServicesDefaultDecoder,
  CreateCdsServiceT,
  createCdsServiceDefaultDecoder,
  DeleteCdsServiceT,
  deleteCdsServiceDefaultDecoder,
  GetCdsServiceT,
  getCdsServiceDefaultDecoder,
  UpdateCdsServiceT,
  updateCdsServiceDefaultDecoder,
  GetCdsSubjectsT,
  getCdsSubjectsDefaultDecoder,
  CreateCdsSubjectT,
  createCdsSubjectDefaultDecoder,
  DeleteCdsSubjectT,
  deleteCdsSubjectDefaultDecoder,
  GetCdsSubjectT,
  getCdsSubjectDefaultDecoder,
  UpdateCdsSubjectT,
  updateCdsSubjectDefaultDecoder,
  GetCdsSubjectServicesT,
  getCdsSubjectServicesDefaultDecoder,
  CreateCdsSubjectServiceT,
  createCdsSubjectServiceDefaultDecoder,
  DeleteCdsSubjectServiceT,
  deleteCdsSubjectServiceDefaultDecoder,
  GetCdsSubjectServiceT,
  getCdsSubjectServiceDefaultDecoder,
  UpdateCdsSubjectServiceT,
  updateCdsSubjectServiceDefaultDecoder,
  GetChannelsT,
  getChannelsDefaultDecoder,
  CreateChannelT,
  createChannelDefaultDecoder,
  GetChannelsCSVT,
  getChannelsCSVDefaultDecoder,
  DeleteChannelT,
  deleteChannelDefaultDecoder,
  GetChannelT,
  getChannelDefaultDecoder,
  UpdateChannelT,
  updateChannelDefaultDecoder,
  GetChannelPaymentServiceProvidersT,
  getChannelPaymentServiceProvidersDefaultDecoder,
  GetChannelPaymentServiceProvidersCSVT,
  getChannelPaymentServiceProvidersCSVDefaultDecoder,
  GetChannelPaymentTypesT,
  getChannelPaymentTypesDefaultDecoder,
  CreateChannelPaymentTypeT,
  createChannelPaymentTypeDefaultDecoder,
  DeleteChannelPaymentTypeT,
  deleteChannelPaymentTypeDefaultDecoder,
  GetFtpServersT,
  getFtpServersDefaultDecoder,
  CreateFtpServerT,
  createFtpServerDefaultDecoder,
  DeleteFtpServerT,
  deleteFtpServerDefaultDecoder,
  GetFtpServerT,
  getFtpServerDefaultDecoder,
  UpdateFtpServerT,
  updateFtpServerDefaultDecoder,
  GetConfigurationKeysT,
  getConfigurationKeysDefaultDecoder,
  CreateConfigurationKeyT,
  createConfigurationKeyDefaultDecoder,
  DeleteConfigurationKeyT,
  deleteConfigurationKeyDefaultDecoder,
  GetConfigurationKeyT,
  getConfigurationKeyDefaultDecoder,
  UpdateConfigurationKeyT,
  updateConfigurationKeyDefaultDecoder,
  GetPaymentTypesT,
  getPaymentTypesDefaultDecoder,
  CreatePaymentTypeT,
  createPaymentTypeDefaultDecoder,
  UploadHistoryT,
  uploadHistoryDefaultDecoder,
  DeletePaymentTypeT,
  deletePaymentTypeDefaultDecoder,
  GetPaymentTypeT,
  getPaymentTypeDefaultDecoder,
  UpdatePaymentTypeT,
  updatePaymentTypeDefaultDecoder,
  GetPddsT,
  getPddsDefaultDecoder,
  CreatePddT,
  createPddDefaultDecoder,
  DeletePddT,
  deletePddDefaultDecoder,
  GetPddT,
  getPddDefaultDecoder,
  UpdatePddT,
  updatePddDefaultDecoder,
  GetWfespPluginsT,
  getWfespPluginsDefaultDecoder,
  CreateWfespPluginT,
  createWfespPluginDefaultDecoder,
  DeleteWfespPluginT,
  deleteWfespPluginDefaultDecoder,
  GetWfespPluginT,
  getWfespPluginDefaultDecoder,
  UpdateWfespPluginT,
  updateWfespPluginDefaultDecoder,
  GetCounterpartTablesT,
  getCounterpartTablesDefaultDecoder,
  CreateCounterpartTableT,
  createCounterpartTableDefaultDecoder,
  DeleteCounterpartTableT,
  deleteCounterpartTableDefaultDecoder,
  GetCounterpartTableT,
  getCounterpartTableDefaultDecoder,
  GetCreditorInstitutionsT,
  getCreditorInstitutionsDefaultDecoder,
  CreateCreditorInstitutionT,
  createCreditorInstitutionDefaultDecoder,
  MassiveUploadCbillCsvT,
  massiveUploadCbillCsvDefaultDecoder,
  MassiveCreateIbansT,
  massiveCreateIbansDefaultDecoder,
  MassiveCreateIbansCsvT,
  massiveCreateIbansCsvDefaultDecoder,
  UpsertIbanLabelT,
  upsertIbanLabelDefaultDecoder,
  GetCreditorInstitutionsViewT,
  getCreditorInstitutionsViewDefaultDecoder,
  DeleteCreditorInstitutionT,
  deleteCreditorInstitutionDefaultDecoder,
  GetCreditorInstitutionT,
  getCreditorInstitutionDefaultDecoder,
  UpdateCreditorInstitutionT,
  updateCreditorInstitutionDefaultDecoder,
  GetCreditorInstitutionEncodingsT,
  getCreditorInstitutionEncodingsDefaultDecoder,
  CreateCreditorInstitutionEncodingT,
  createCreditorInstitutionEncodingDefaultDecoder,
  DeleteCreditorInstitutionEncodingT,
  deleteCreditorInstitutionEncodingDefaultDecoder,
  GetCreditorInstitutionsIbansT,
  getCreditorInstitutionsIbansDefaultDecoder,
  CreateCreditorInstitutionsIbansT,
  createCreditorInstitutionsIbansDefaultDecoder,
  GetIbansT,
  getIbansDefaultDecoder,
  UpdateCreditorInstitutionsIbansT,
  updateCreditorInstitutionsIbansDefaultDecoder,
  DeleteCreditorInstitutionsIbanT,
  deleteCreditorInstitutionsIbanDefaultDecoder,
  GetCreditorInstitutionStationsT,
  getCreditorInstitutionStationsDefaultDecoder,
  CreateCreditorInstitutionStationT,
  createCreditorInstitutionStationDefaultDecoder,
  DeleteCreditorInstitutionStationT,
  deleteCreditorInstitutionStationDefaultDecoder,
  UpdateCreditorInstitutionStationT,
  updateCreditorInstitutionStationDefaultDecoder,
  GetCreditorInstitutionByPostalEncodingT,
  getCreditorInstitutionByPostalEncodingDefaultDecoder,
  GetCreditorInstitutionsByIbanT,
  getCreditorInstitutionsByIbanDefaultDecoder,
  GetIcasT,
  getIcasDefaultDecoder,
  CreateIcaT,
  createIcaDefaultDecoder,
  VerifyIcaT,
  verifyIcaDefaultDecoder,
  MassiveVerifyIcasT,
  massiveVerifyIcasDefaultDecoder,
  MassiveCreateIcasT,
  massiveCreateIcasDefaultDecoder,
  CheckXSDT,
  checkXSDDefaultDecoder,
  DeleteIcaT,
  deleteIcaDefaultDecoder,
  GetIcaT,
  getIcaDefaultDecoder,
  HealthCheckT,
  healthCheckDefaultDecoder,
  GetPaymentServiceProvidersT,
  getPaymentServiceProvidersDefaultDecoder,
  CreatePaymentServiceProviderT,
  createPaymentServiceProviderDefaultDecoder,
  GetPaymentServiceProvidersViewT,
  getPaymentServiceProvidersViewDefaultDecoder,
  DeletePaymentServiceProviderT,
  deletePaymentServiceProviderDefaultDecoder,
  GetPaymentServiceProviderT,
  getPaymentServiceProviderDefaultDecoder,
  UpdatePaymentServiceProviderT,
  updatePaymentServiceProviderDefaultDecoder,
  GetPaymentServiceProvidersChannelsT,
  getPaymentServiceProvidersChannelsDefaultDecoder,
  CreatePaymentServiceProvidersChannelsT,
  createPaymentServiceProvidersChannelsDefaultDecoder,
  DeletePaymentServiceProvidersChannelsT,
  deletePaymentServiceProvidersChannelsDefaultDecoder,
  UpdatePaymentServiceProvidersChannelsT,
  updatePaymentServiceProvidersChannelsDefaultDecoder,
  GetRefreshGlobalConfigT,
  getRefreshGlobalConfigDefaultDecoder,
  GetJobTriggerT,
  getJobTriggerDefaultDecoder,
  GetServicesT,
  getServicesDefaultDecoder,
  GetStationsT,
  getStationsDefaultDecoder,
  CreateStationT,
  createStationDefaultDecoder,
  GetStationsCSVT,
  getStationsCSVDefaultDecoder,
  DeleteStationT,
  deleteStationDefaultDecoder,
  GetStationT,
  getStationDefaultDecoder,
  UpdateStationT,
  updateStationDefaultDecoder,
  GetStationCreditorInstitutionsT,
  getStationCreditorInstitutionsDefaultDecoder,
  GetStationCreditorInstitutionsCSVT,
  getStationCreditorInstitutionsCSVDefaultDecoder,
  GetStationCreditorInstitutionRelationT,
  getStationCreditorInstitutionRelationDefaultDecoder
} from "./requestTypes";

// This is a placeholder for undefined when dealing with object keys
// Typescript doesn't perform well when narrowing a union type which includes string and undefined
// (example: "foo" | "bar" | undefined)
// We use this as a placeholder for type parameters indicating "no key"
type __UNDEFINED_KEY = "_____";

export type ApiOperation = TypeofApiCall<ManageCIStationRelationshipT> &
  TypeofApiCall<MassiveMigrationT> &
  TypeofApiCall<GetBrokersT> &
  TypeofApiCall<CreateBrokerT> &
  TypeofApiCall<GetAllStationsMaintenancesT> &
  TypeofApiCall<DeleteBrokerT> &
  TypeofApiCall<GetBrokerT> &
  TypeofApiCall<UpdateBrokerT> &
  TypeofApiCall<GetStationMaintenancesT> &
  TypeofApiCall<CreateStationMaintenanceT> &
  TypeofApiCall<GetBrokerMaintenancesSummaryT> &
  TypeofApiCall<DeleteStationMaintenanceT> &
  TypeofApiCall<GetStationMaintenanceT> &
  TypeofApiCall<UpdateStationMaintenanceT> &
  TypeofApiCall<GetBrokersPspT> &
  TypeofApiCall<CreateBrokerPspT> &
  TypeofApiCall<DeleteBrokerPspT> &
  TypeofApiCall<GetBrokerPspT> &
  TypeofApiCall<UpdateBrokerPspT> &
  TypeofApiCall<GetPspBrokerPspT> &
  TypeofApiCall<GetCacheVersionsT> &
  TypeofApiCall<GetCacheByVersionT> &
  TypeofApiCall<GetCacheIdT> &
  TypeofApiCall<GetCdisT> &
  TypeofApiCall<CreateCdiT> &
  TypeofApiCall<VerifyCdiT> &
  TypeofApiCall<UploadHistory_1T> &
  TypeofApiCall<DeleteCdiT> &
  TypeofApiCall<GetCdiT> &
  TypeofApiCall<GetCdsServicesT> &
  TypeofApiCall<CreateCdsServiceT> &
  TypeofApiCall<DeleteCdsServiceT> &
  TypeofApiCall<GetCdsServiceT> &
  TypeofApiCall<UpdateCdsServiceT> &
  TypeofApiCall<GetCdsSubjectsT> &
  TypeofApiCall<CreateCdsSubjectT> &
  TypeofApiCall<DeleteCdsSubjectT> &
  TypeofApiCall<GetCdsSubjectT> &
  TypeofApiCall<UpdateCdsSubjectT> &
  TypeofApiCall<GetCdsSubjectServicesT> &
  TypeofApiCall<CreateCdsSubjectServiceT> &
  TypeofApiCall<DeleteCdsSubjectServiceT> &
  TypeofApiCall<GetCdsSubjectServiceT> &
  TypeofApiCall<UpdateCdsSubjectServiceT> &
  TypeofApiCall<GetChannelsT> &
  TypeofApiCall<CreateChannelT> &
  TypeofApiCall<GetChannelsCSVT> &
  TypeofApiCall<DeleteChannelT> &
  TypeofApiCall<GetChannelT> &
  TypeofApiCall<UpdateChannelT> &
  TypeofApiCall<GetChannelPaymentServiceProvidersT> &
  TypeofApiCall<GetChannelPaymentServiceProvidersCSVT> &
  TypeofApiCall<GetChannelPaymentTypesT> &
  TypeofApiCall<CreateChannelPaymentTypeT> &
  TypeofApiCall<DeleteChannelPaymentTypeT> &
  TypeofApiCall<GetFtpServersT> &
  TypeofApiCall<CreateFtpServerT> &
  TypeofApiCall<DeleteFtpServerT> &
  TypeofApiCall<GetFtpServerT> &
  TypeofApiCall<UpdateFtpServerT> &
  TypeofApiCall<GetConfigurationKeysT> &
  TypeofApiCall<CreateConfigurationKeyT> &
  TypeofApiCall<DeleteConfigurationKeyT> &
  TypeofApiCall<GetConfigurationKeyT> &
  TypeofApiCall<UpdateConfigurationKeyT> &
  TypeofApiCall<GetPaymentTypesT> &
  TypeofApiCall<CreatePaymentTypeT> &
  TypeofApiCall<UploadHistoryT> &
  TypeofApiCall<DeletePaymentTypeT> &
  TypeofApiCall<GetPaymentTypeT> &
  TypeofApiCall<UpdatePaymentTypeT> &
  TypeofApiCall<GetPddsT> &
  TypeofApiCall<CreatePddT> &
  TypeofApiCall<DeletePddT> &
  TypeofApiCall<GetPddT> &
  TypeofApiCall<UpdatePddT> &
  TypeofApiCall<GetWfespPluginsT> &
  TypeofApiCall<CreateWfespPluginT> &
  TypeofApiCall<DeleteWfespPluginT> &
  TypeofApiCall<GetWfespPluginT> &
  TypeofApiCall<UpdateWfespPluginT> &
  TypeofApiCall<GetCounterpartTablesT> &
  TypeofApiCall<CreateCounterpartTableT> &
  TypeofApiCall<DeleteCounterpartTableT> &
  TypeofApiCall<GetCounterpartTableT> &
  TypeofApiCall<GetCreditorInstitutionsT> &
  TypeofApiCall<CreateCreditorInstitutionT> &
  TypeofApiCall<MassiveUploadCbillCsvT> &
  TypeofApiCall<MassiveCreateIbansT> &
  TypeofApiCall<MassiveCreateIbansCsvT> &
  TypeofApiCall<UpsertIbanLabelT> &
  TypeofApiCall<GetCreditorInstitutionsViewT> &
  TypeofApiCall<DeleteCreditorInstitutionT> &
  TypeofApiCall<GetCreditorInstitutionT> &
  TypeofApiCall<UpdateCreditorInstitutionT> &
  TypeofApiCall<GetCreditorInstitutionEncodingsT> &
  TypeofApiCall<CreateCreditorInstitutionEncodingT> &
  TypeofApiCall<DeleteCreditorInstitutionEncodingT> &
  TypeofApiCall<GetCreditorInstitutionsIbansT> &
  TypeofApiCall<CreateCreditorInstitutionsIbansT> &
  TypeofApiCall<GetIbansT> &
  TypeofApiCall<UpdateCreditorInstitutionsIbansT> &
  TypeofApiCall<DeleteCreditorInstitutionsIbanT> &
  TypeofApiCall<GetCreditorInstitutionStationsT> &
  TypeofApiCall<CreateCreditorInstitutionStationT> &
  TypeofApiCall<DeleteCreditorInstitutionStationT> &
  TypeofApiCall<UpdateCreditorInstitutionStationT> &
  TypeofApiCall<GetCreditorInstitutionByPostalEncodingT> &
  TypeofApiCall<GetCreditorInstitutionsByIbanT> &
  TypeofApiCall<GetIcasT> &
  TypeofApiCall<CreateIcaT> &
  TypeofApiCall<VerifyIcaT> &
  TypeofApiCall<MassiveVerifyIcasT> &
  TypeofApiCall<MassiveCreateIcasT> &
  TypeofApiCall<CheckXSDT> &
  TypeofApiCall<DeleteIcaT> &
  TypeofApiCall<GetIcaT> &
  TypeofApiCall<HealthCheckT> &
  TypeofApiCall<GetPaymentServiceProvidersT> &
  TypeofApiCall<CreatePaymentServiceProviderT> &
  TypeofApiCall<GetPaymentServiceProvidersViewT> &
  TypeofApiCall<DeletePaymentServiceProviderT> &
  TypeofApiCall<GetPaymentServiceProviderT> &
  TypeofApiCall<UpdatePaymentServiceProviderT> &
  TypeofApiCall<GetPaymentServiceProvidersChannelsT> &
  TypeofApiCall<CreatePaymentServiceProvidersChannelsT> &
  TypeofApiCall<DeletePaymentServiceProvidersChannelsT> &
  TypeofApiCall<UpdatePaymentServiceProvidersChannelsT> &
  TypeofApiCall<GetRefreshGlobalConfigT> &
  TypeofApiCall<GetJobTriggerT> &
  TypeofApiCall<GetServicesT> &
  TypeofApiCall<GetStationsT> &
  TypeofApiCall<CreateStationT> &
  TypeofApiCall<GetStationsCSVT> &
  TypeofApiCall<DeleteStationT> &
  TypeofApiCall<GetStationT> &
  TypeofApiCall<UpdateStationT> &
  TypeofApiCall<GetStationCreditorInstitutionsT> &
  TypeofApiCall<GetStationCreditorInstitutionsCSVT> &
  TypeofApiCall<GetStationCreditorInstitutionRelationT>;

export type ParamKeys = keyof (TypeofApiParams<ManageCIStationRelationshipT> &
  TypeofApiParams<MassiveMigrationT> &
  TypeofApiParams<GetBrokersT> &
  TypeofApiParams<CreateBrokerT> &
  TypeofApiParams<GetAllStationsMaintenancesT> &
  TypeofApiParams<DeleteBrokerT> &
  TypeofApiParams<GetBrokerT> &
  TypeofApiParams<UpdateBrokerT> &
  TypeofApiParams<GetStationMaintenancesT> &
  TypeofApiParams<CreateStationMaintenanceT> &
  TypeofApiParams<GetBrokerMaintenancesSummaryT> &
  TypeofApiParams<DeleteStationMaintenanceT> &
  TypeofApiParams<GetStationMaintenanceT> &
  TypeofApiParams<UpdateStationMaintenanceT> &
  TypeofApiParams<GetBrokersPspT> &
  TypeofApiParams<CreateBrokerPspT> &
  TypeofApiParams<DeleteBrokerPspT> &
  TypeofApiParams<GetBrokerPspT> &
  TypeofApiParams<UpdateBrokerPspT> &
  TypeofApiParams<GetPspBrokerPspT> &
  TypeofApiParams<GetCacheVersionsT> &
  TypeofApiParams<GetCacheByVersionT> &
  TypeofApiParams<GetCacheIdT> &
  TypeofApiParams<GetCdisT> &
  TypeofApiParams<CreateCdiT> &
  TypeofApiParams<VerifyCdiT> &
  TypeofApiParams<UploadHistory_1T> &
  TypeofApiParams<DeleteCdiT> &
  TypeofApiParams<GetCdiT> &
  TypeofApiParams<GetCdsServicesT> &
  TypeofApiParams<CreateCdsServiceT> &
  TypeofApiParams<DeleteCdsServiceT> &
  TypeofApiParams<GetCdsServiceT> &
  TypeofApiParams<UpdateCdsServiceT> &
  TypeofApiParams<GetCdsSubjectsT> &
  TypeofApiParams<CreateCdsSubjectT> &
  TypeofApiParams<DeleteCdsSubjectT> &
  TypeofApiParams<GetCdsSubjectT> &
  TypeofApiParams<UpdateCdsSubjectT> &
  TypeofApiParams<GetCdsSubjectServicesT> &
  TypeofApiParams<CreateCdsSubjectServiceT> &
  TypeofApiParams<DeleteCdsSubjectServiceT> &
  TypeofApiParams<GetCdsSubjectServiceT> &
  TypeofApiParams<UpdateCdsSubjectServiceT> &
  TypeofApiParams<GetChannelsT> &
  TypeofApiParams<CreateChannelT> &
  TypeofApiParams<GetChannelsCSVT> &
  TypeofApiParams<DeleteChannelT> &
  TypeofApiParams<GetChannelT> &
  TypeofApiParams<UpdateChannelT> &
  TypeofApiParams<GetChannelPaymentServiceProvidersT> &
  TypeofApiParams<GetChannelPaymentServiceProvidersCSVT> &
  TypeofApiParams<GetChannelPaymentTypesT> &
  TypeofApiParams<CreateChannelPaymentTypeT> &
  TypeofApiParams<DeleteChannelPaymentTypeT> &
  TypeofApiParams<GetFtpServersT> &
  TypeofApiParams<CreateFtpServerT> &
  TypeofApiParams<DeleteFtpServerT> &
  TypeofApiParams<GetFtpServerT> &
  TypeofApiParams<UpdateFtpServerT> &
  TypeofApiParams<GetConfigurationKeysT> &
  TypeofApiParams<CreateConfigurationKeyT> &
  TypeofApiParams<DeleteConfigurationKeyT> &
  TypeofApiParams<GetConfigurationKeyT> &
  TypeofApiParams<UpdateConfigurationKeyT> &
  TypeofApiParams<GetPaymentTypesT> &
  TypeofApiParams<CreatePaymentTypeT> &
  TypeofApiParams<UploadHistoryT> &
  TypeofApiParams<DeletePaymentTypeT> &
  TypeofApiParams<GetPaymentTypeT> &
  TypeofApiParams<UpdatePaymentTypeT> &
  TypeofApiParams<GetPddsT> &
  TypeofApiParams<CreatePddT> &
  TypeofApiParams<DeletePddT> &
  TypeofApiParams<GetPddT> &
  TypeofApiParams<UpdatePddT> &
  TypeofApiParams<GetWfespPluginsT> &
  TypeofApiParams<CreateWfespPluginT> &
  TypeofApiParams<DeleteWfespPluginT> &
  TypeofApiParams<GetWfespPluginT> &
  TypeofApiParams<UpdateWfespPluginT> &
  TypeofApiParams<GetCounterpartTablesT> &
  TypeofApiParams<CreateCounterpartTableT> &
  TypeofApiParams<DeleteCounterpartTableT> &
  TypeofApiParams<GetCounterpartTableT> &
  TypeofApiParams<GetCreditorInstitutionsT> &
  TypeofApiParams<CreateCreditorInstitutionT> &
  TypeofApiParams<MassiveUploadCbillCsvT> &
  TypeofApiParams<MassiveCreateIbansT> &
  TypeofApiParams<MassiveCreateIbansCsvT> &
  TypeofApiParams<UpsertIbanLabelT> &
  TypeofApiParams<GetCreditorInstitutionsViewT> &
  TypeofApiParams<DeleteCreditorInstitutionT> &
  TypeofApiParams<GetCreditorInstitutionT> &
  TypeofApiParams<UpdateCreditorInstitutionT> &
  TypeofApiParams<GetCreditorInstitutionEncodingsT> &
  TypeofApiParams<CreateCreditorInstitutionEncodingT> &
  TypeofApiParams<DeleteCreditorInstitutionEncodingT> &
  TypeofApiParams<GetCreditorInstitutionsIbansT> &
  TypeofApiParams<CreateCreditorInstitutionsIbansT> &
  TypeofApiParams<GetIbansT> &
  TypeofApiParams<UpdateCreditorInstitutionsIbansT> &
  TypeofApiParams<DeleteCreditorInstitutionsIbanT> &
  TypeofApiParams<GetCreditorInstitutionStationsT> &
  TypeofApiParams<CreateCreditorInstitutionStationT> &
  TypeofApiParams<DeleteCreditorInstitutionStationT> &
  TypeofApiParams<UpdateCreditorInstitutionStationT> &
  TypeofApiParams<GetCreditorInstitutionByPostalEncodingT> &
  TypeofApiParams<GetCreditorInstitutionsByIbanT> &
  TypeofApiParams<GetIcasT> &
  TypeofApiParams<CreateIcaT> &
  TypeofApiParams<VerifyIcaT> &
  TypeofApiParams<MassiveVerifyIcasT> &
  TypeofApiParams<MassiveCreateIcasT> &
  TypeofApiParams<CheckXSDT> &
  TypeofApiParams<DeleteIcaT> &
  TypeofApiParams<GetIcaT> &
  TypeofApiParams<HealthCheckT> &
  TypeofApiParams<GetPaymentServiceProvidersT> &
  TypeofApiParams<CreatePaymentServiceProviderT> &
  TypeofApiParams<GetPaymentServiceProvidersViewT> &
  TypeofApiParams<DeletePaymentServiceProviderT> &
  TypeofApiParams<GetPaymentServiceProviderT> &
  TypeofApiParams<UpdatePaymentServiceProviderT> &
  TypeofApiParams<GetPaymentServiceProvidersChannelsT> &
  TypeofApiParams<CreatePaymentServiceProvidersChannelsT> &
  TypeofApiParams<DeletePaymentServiceProvidersChannelsT> &
  TypeofApiParams<UpdatePaymentServiceProvidersChannelsT> &
  TypeofApiParams<GetRefreshGlobalConfigT> &
  TypeofApiParams<GetJobTriggerT> &
  TypeofApiParams<GetServicesT> &
  TypeofApiParams<GetStationsT> &
  TypeofApiParams<CreateStationT> &
  TypeofApiParams<GetStationsCSVT> &
  TypeofApiParams<DeleteStationT> &
  TypeofApiParams<GetStationT> &
  TypeofApiParams<UpdateStationT> &
  TypeofApiParams<GetStationCreditorInstitutionsT> &
  TypeofApiParams<GetStationCreditorInstitutionsCSVT> &
  TypeofApiParams<GetStationCreditorInstitutionRelationT>);

/**
 * Defines an adapter for TypeofApiCall which omit one or more parameters in the signature
 * @param ApiT the type which defines the operation to expose
 * @param K the parameter to omit. undefined means no parameters will be omitted
 */
export type OmitApiCallParams<
  ApiT,
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = (
  op: TypeofApiCall<ApiT>
) => K extends __UNDEFINED_KEY
  ? TypeofApiCall<ApiT>
  : TypeofApiCall<ReplaceRequestParams<ApiT, Omit<RequestParams<ApiT>, K>>>;

/**
 * Defines an adapter for TypeofApiCall which omit one or more parameters in the signature
 * @param ApiT the type which defines the operation to expose
 * @param K the parameter to omit. undefined means no parameters will be omitted
 */
export type WithDefaultsT<
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = OmitApiCallParams<
  | ManageCIStationRelationshipT
  | MassiveMigrationT
  | GetBrokersT
  | CreateBrokerT
  | GetAllStationsMaintenancesT
  | DeleteBrokerT
  | GetBrokerT
  | UpdateBrokerT
  | GetStationMaintenancesT
  | CreateStationMaintenanceT
  | GetBrokerMaintenancesSummaryT
  | DeleteStationMaintenanceT
  | GetStationMaintenanceT
  | UpdateStationMaintenanceT
  | GetBrokersPspT
  | CreateBrokerPspT
  | DeleteBrokerPspT
  | GetBrokerPspT
  | UpdateBrokerPspT
  | GetPspBrokerPspT
  | GetCacheVersionsT
  | GetCacheByVersionT
  | GetCacheIdT
  | GetCdisT
  | CreateCdiT
  | VerifyCdiT
  | UploadHistory_1T
  | DeleteCdiT
  | GetCdiT
  | GetCdsServicesT
  | CreateCdsServiceT
  | DeleteCdsServiceT
  | GetCdsServiceT
  | UpdateCdsServiceT
  | GetCdsSubjectsT
  | CreateCdsSubjectT
  | DeleteCdsSubjectT
  | GetCdsSubjectT
  | UpdateCdsSubjectT
  | GetCdsSubjectServicesT
  | CreateCdsSubjectServiceT
  | DeleteCdsSubjectServiceT
  | GetCdsSubjectServiceT
  | UpdateCdsSubjectServiceT
  | GetChannelsT
  | CreateChannelT
  | GetChannelsCSVT
  | DeleteChannelT
  | GetChannelT
  | UpdateChannelT
  | GetChannelPaymentServiceProvidersT
  | GetChannelPaymentServiceProvidersCSVT
  | GetChannelPaymentTypesT
  | CreateChannelPaymentTypeT
  | DeleteChannelPaymentTypeT
  | GetFtpServersT
  | CreateFtpServerT
  | DeleteFtpServerT
  | GetFtpServerT
  | UpdateFtpServerT
  | GetConfigurationKeysT
  | CreateConfigurationKeyT
  | DeleteConfigurationKeyT
  | GetConfigurationKeyT
  | UpdateConfigurationKeyT
  | GetPaymentTypesT
  | CreatePaymentTypeT
  | UploadHistoryT
  | DeletePaymentTypeT
  | GetPaymentTypeT
  | UpdatePaymentTypeT
  | GetPddsT
  | CreatePddT
  | DeletePddT
  | GetPddT
  | UpdatePddT
  | GetWfespPluginsT
  | CreateWfespPluginT
  | DeleteWfespPluginT
  | GetWfespPluginT
  | UpdateWfespPluginT
  | GetCounterpartTablesT
  | CreateCounterpartTableT
  | DeleteCounterpartTableT
  | GetCounterpartTableT
  | GetCreditorInstitutionsT
  | CreateCreditorInstitutionT
  | MassiveUploadCbillCsvT
  | MassiveCreateIbansT
  | MassiveCreateIbansCsvT
  | UpsertIbanLabelT
  | GetCreditorInstitutionsViewT
  | DeleteCreditorInstitutionT
  | GetCreditorInstitutionT
  | UpdateCreditorInstitutionT
  | GetCreditorInstitutionEncodingsT
  | CreateCreditorInstitutionEncodingT
  | DeleteCreditorInstitutionEncodingT
  | GetCreditorInstitutionsIbansT
  | CreateCreditorInstitutionsIbansT
  | GetIbansT
  | UpdateCreditorInstitutionsIbansT
  | DeleteCreditorInstitutionsIbanT
  | GetCreditorInstitutionStationsT
  | CreateCreditorInstitutionStationT
  | DeleteCreditorInstitutionStationT
  | UpdateCreditorInstitutionStationT
  | GetCreditorInstitutionByPostalEncodingT
  | GetCreditorInstitutionsByIbanT
  | GetIcasT
  | CreateIcaT
  | VerifyIcaT
  | MassiveVerifyIcasT
  | MassiveCreateIcasT
  | CheckXSDT
  | DeleteIcaT
  | GetIcaT
  | HealthCheckT
  | GetPaymentServiceProvidersT
  | CreatePaymentServiceProviderT
  | GetPaymentServiceProvidersViewT
  | DeletePaymentServiceProviderT
  | GetPaymentServiceProviderT
  | UpdatePaymentServiceProviderT
  | GetPaymentServiceProvidersChannelsT
  | CreatePaymentServiceProvidersChannelsT
  | DeletePaymentServiceProvidersChannelsT
  | UpdatePaymentServiceProvidersChannelsT
  | GetRefreshGlobalConfigT
  | GetJobTriggerT
  | GetServicesT
  | GetStationsT
  | CreateStationT
  | GetStationsCSVT
  | DeleteStationT
  | GetStationT
  | UpdateStationT
  | GetStationCreditorInstitutionsT
  | GetStationCreditorInstitutionsCSVT
  | GetStationCreditorInstitutionRelationT,
  K
>;

/**
 * Defines a collection of api operations
 * @param K name of the parameters that the Clients masks from the operations
 */
export type Client<
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = K extends __UNDEFINED_KEY
  ? {
      readonly manageCIStationRelationship: TypeofApiCall<
        ManageCIStationRelationshipT
      >;

      readonly massiveMigration: TypeofApiCall<MassiveMigrationT>;

      readonly getBrokers: TypeofApiCall<GetBrokersT>;

      readonly createBroker: TypeofApiCall<CreateBrokerT>;

      readonly getAllStationsMaintenances: TypeofApiCall<
        GetAllStationsMaintenancesT
      >;

      readonly deleteBroker: TypeofApiCall<DeleteBrokerT>;

      readonly getBroker: TypeofApiCall<GetBrokerT>;

      readonly updateBroker: TypeofApiCall<UpdateBrokerT>;

      readonly getStationMaintenances: TypeofApiCall<GetStationMaintenancesT>;

      readonly createStationMaintenance: TypeofApiCall<
        CreateStationMaintenanceT
      >;

      readonly getBrokerMaintenancesSummary: TypeofApiCall<
        GetBrokerMaintenancesSummaryT
      >;

      readonly deleteStationMaintenance: TypeofApiCall<
        DeleteStationMaintenanceT
      >;

      readonly getStationMaintenance: TypeofApiCall<GetStationMaintenanceT>;

      readonly updateStationMaintenance: TypeofApiCall<
        UpdateStationMaintenanceT
      >;

      readonly getBrokersPsp: TypeofApiCall<GetBrokersPspT>;

      readonly createBrokerPsp: TypeofApiCall<CreateBrokerPspT>;

      readonly deleteBrokerPsp: TypeofApiCall<DeleteBrokerPspT>;

      readonly getBrokerPsp: TypeofApiCall<GetBrokerPspT>;

      readonly updateBrokerPsp: TypeofApiCall<UpdateBrokerPspT>;

      readonly getPspBrokerPsp: TypeofApiCall<GetPspBrokerPspT>;

      readonly getCacheVersions: TypeofApiCall<GetCacheVersionsT>;

      readonly getCacheByVersion: TypeofApiCall<GetCacheByVersionT>;

      readonly getCacheId: TypeofApiCall<GetCacheIdT>;

      readonly getCdis: TypeofApiCall<GetCdisT>;

      readonly createCdi: TypeofApiCall<CreateCdiT>;

      readonly verifyCdi: TypeofApiCall<VerifyCdiT>;

      readonly uploadHistory_1: TypeofApiCall<UploadHistory_1T>;

      readonly deleteCdi: TypeofApiCall<DeleteCdiT>;

      readonly getCdi: TypeofApiCall<GetCdiT>;

      readonly getCdsServices: TypeofApiCall<GetCdsServicesT>;

      readonly createCdsService: TypeofApiCall<CreateCdsServiceT>;

      readonly deleteCdsService: TypeofApiCall<DeleteCdsServiceT>;

      readonly getCdsService: TypeofApiCall<GetCdsServiceT>;

      readonly updateCdsService: TypeofApiCall<UpdateCdsServiceT>;

      readonly getCdsSubjects: TypeofApiCall<GetCdsSubjectsT>;

      readonly createCdsSubject: TypeofApiCall<CreateCdsSubjectT>;

      readonly deleteCdsSubject: TypeofApiCall<DeleteCdsSubjectT>;

      readonly getCdsSubject: TypeofApiCall<GetCdsSubjectT>;

      readonly updateCdsSubject: TypeofApiCall<UpdateCdsSubjectT>;

      readonly getCdsSubjectServices: TypeofApiCall<GetCdsSubjectServicesT>;

      readonly createCdsSubjectService: TypeofApiCall<CreateCdsSubjectServiceT>;

      readonly deleteCdsSubjectService: TypeofApiCall<DeleteCdsSubjectServiceT>;

      readonly getCdsSubjectService: TypeofApiCall<GetCdsSubjectServiceT>;

      readonly updateCdsSubjectService: TypeofApiCall<UpdateCdsSubjectServiceT>;

      readonly getChannels: TypeofApiCall<GetChannelsT>;

      readonly createChannel: TypeofApiCall<CreateChannelT>;

      readonly getChannelsCSV: TypeofApiCall<GetChannelsCSVT>;

      readonly deleteChannel: TypeofApiCall<DeleteChannelT>;

      readonly getChannel: TypeofApiCall<GetChannelT>;

      readonly updateChannel: TypeofApiCall<UpdateChannelT>;

      readonly getChannelPaymentServiceProviders: TypeofApiCall<
        GetChannelPaymentServiceProvidersT
      >;

      readonly getChannelPaymentServiceProvidersCSV: TypeofApiCall<
        GetChannelPaymentServiceProvidersCSVT
      >;

      readonly getChannelPaymentTypes: TypeofApiCall<GetChannelPaymentTypesT>;

      readonly createChannelPaymentType: TypeofApiCall<
        CreateChannelPaymentTypeT
      >;

      readonly deleteChannelPaymentType: TypeofApiCall<
        DeleteChannelPaymentTypeT
      >;

      readonly getFtpServers: TypeofApiCall<GetFtpServersT>;

      readonly createFtpServer: TypeofApiCall<CreateFtpServerT>;

      readonly deleteFtpServer: TypeofApiCall<DeleteFtpServerT>;

      readonly getFtpServer: TypeofApiCall<GetFtpServerT>;

      readonly updateFtpServer: TypeofApiCall<UpdateFtpServerT>;

      readonly getConfigurationKeys: TypeofApiCall<GetConfigurationKeysT>;

      readonly createConfigurationKey: TypeofApiCall<CreateConfigurationKeyT>;

      readonly deleteConfigurationKey: TypeofApiCall<DeleteConfigurationKeyT>;

      readonly getConfigurationKey: TypeofApiCall<GetConfigurationKeyT>;

      readonly updateConfigurationKey: TypeofApiCall<UpdateConfigurationKeyT>;

      readonly getPaymentTypes: TypeofApiCall<GetPaymentTypesT>;

      readonly createPaymentType: TypeofApiCall<CreatePaymentTypeT>;

      readonly uploadHistory: TypeofApiCall<UploadHistoryT>;

      readonly deletePaymentType: TypeofApiCall<DeletePaymentTypeT>;

      readonly getPaymentType: TypeofApiCall<GetPaymentTypeT>;

      readonly updatePaymentType: TypeofApiCall<UpdatePaymentTypeT>;

      readonly getPdds: TypeofApiCall<GetPddsT>;

      readonly createPdd: TypeofApiCall<CreatePddT>;

      readonly deletePdd: TypeofApiCall<DeletePddT>;

      readonly getPdd: TypeofApiCall<GetPddT>;

      readonly updatePdd: TypeofApiCall<UpdatePddT>;

      readonly getWfespPlugins: TypeofApiCall<GetWfespPluginsT>;

      readonly createWfespPlugin: TypeofApiCall<CreateWfespPluginT>;

      readonly deleteWfespPlugin: TypeofApiCall<DeleteWfespPluginT>;

      readonly getWfespPlugin: TypeofApiCall<GetWfespPluginT>;

      readonly updateWfespPlugin: TypeofApiCall<UpdateWfespPluginT>;

      readonly getCounterpartTables: TypeofApiCall<GetCounterpartTablesT>;

      readonly createCounterpartTable: TypeofApiCall<CreateCounterpartTableT>;

      readonly deleteCounterpartTable: TypeofApiCall<DeleteCounterpartTableT>;

      readonly getCounterpartTable: TypeofApiCall<GetCounterpartTableT>;

      readonly getCreditorInstitutions: TypeofApiCall<GetCreditorInstitutionsT>;

      readonly createCreditorInstitution: TypeofApiCall<
        CreateCreditorInstitutionT
      >;

      readonly massiveUploadCbillCsv: TypeofApiCall<MassiveUploadCbillCsvT>;

      readonly massiveCreateIbans: TypeofApiCall<MassiveCreateIbansT>;

      readonly massiveCreateIbansCsv: TypeofApiCall<MassiveCreateIbansCsvT>;

      readonly upsertIbanLabel: TypeofApiCall<UpsertIbanLabelT>;

      readonly getCreditorInstitutionsView: TypeofApiCall<
        GetCreditorInstitutionsViewT
      >;

      readonly deleteCreditorInstitution: TypeofApiCall<
        DeleteCreditorInstitutionT
      >;

      readonly getCreditorInstitution: TypeofApiCall<GetCreditorInstitutionT>;

      readonly updateCreditorInstitution: TypeofApiCall<
        UpdateCreditorInstitutionT
      >;

      readonly getCreditorInstitutionEncodings: TypeofApiCall<
        GetCreditorInstitutionEncodingsT
      >;

      readonly createCreditorInstitutionEncoding: TypeofApiCall<
        CreateCreditorInstitutionEncodingT
      >;

      readonly deleteCreditorInstitutionEncoding: TypeofApiCall<
        DeleteCreditorInstitutionEncodingT
      >;

      readonly getCreditorInstitutionsIbans: TypeofApiCall<
        GetCreditorInstitutionsIbansT
      >;

      readonly createCreditorInstitutionsIbans: TypeofApiCall<
        CreateCreditorInstitutionsIbansT
      >;

      readonly getIbans: TypeofApiCall<GetIbansT>;

      readonly updateCreditorInstitutionsIbans: TypeofApiCall<
        UpdateCreditorInstitutionsIbansT
      >;

      readonly deleteCreditorInstitutionsIban: TypeofApiCall<
        DeleteCreditorInstitutionsIbanT
      >;

      readonly getCreditorInstitutionStations: TypeofApiCall<
        GetCreditorInstitutionStationsT
      >;

      readonly createCreditorInstitutionStation: TypeofApiCall<
        CreateCreditorInstitutionStationT
      >;

      readonly deleteCreditorInstitutionStation: TypeofApiCall<
        DeleteCreditorInstitutionStationT
      >;

      readonly updateCreditorInstitutionStation: TypeofApiCall<
        UpdateCreditorInstitutionStationT
      >;

      readonly getCreditorInstitutionByPostalEncoding: TypeofApiCall<
        GetCreditorInstitutionByPostalEncodingT
      >;

      readonly getCreditorInstitutionsByIban: TypeofApiCall<
        GetCreditorInstitutionsByIbanT
      >;

      readonly getIcas: TypeofApiCall<GetIcasT>;

      readonly createIca: TypeofApiCall<CreateIcaT>;

      readonly verifyIca: TypeofApiCall<VerifyIcaT>;

      readonly massiveVerifyIcas: TypeofApiCall<MassiveVerifyIcasT>;

      readonly massiveCreateIcas: TypeofApiCall<MassiveCreateIcasT>;

      readonly checkXSD: TypeofApiCall<CheckXSDT>;

      readonly deleteIca: TypeofApiCall<DeleteIcaT>;

      readonly getIca: TypeofApiCall<GetIcaT>;

      readonly healthCheck: TypeofApiCall<HealthCheckT>;

      readonly getPaymentServiceProviders: TypeofApiCall<
        GetPaymentServiceProvidersT
      >;

      readonly createPaymentServiceProvider: TypeofApiCall<
        CreatePaymentServiceProviderT
      >;

      readonly getPaymentServiceProvidersView: TypeofApiCall<
        GetPaymentServiceProvidersViewT
      >;

      readonly deletePaymentServiceProvider: TypeofApiCall<
        DeletePaymentServiceProviderT
      >;

      readonly getPaymentServiceProvider: TypeofApiCall<
        GetPaymentServiceProviderT
      >;

      readonly updatePaymentServiceProvider: TypeofApiCall<
        UpdatePaymentServiceProviderT
      >;

      readonly getPaymentServiceProvidersChannels: TypeofApiCall<
        GetPaymentServiceProvidersChannelsT
      >;

      readonly createPaymentServiceProvidersChannels: TypeofApiCall<
        CreatePaymentServiceProvidersChannelsT
      >;

      readonly deletePaymentServiceProvidersChannels: TypeofApiCall<
        DeletePaymentServiceProvidersChannelsT
      >;

      readonly updatePaymentServiceProvidersChannels: TypeofApiCall<
        UpdatePaymentServiceProvidersChannelsT
      >;

      readonly getRefreshGlobalConfig: TypeofApiCall<GetRefreshGlobalConfigT>;

      readonly getJobTrigger: TypeofApiCall<GetJobTriggerT>;

      readonly getServices: TypeofApiCall<GetServicesT>;

      readonly getStations: TypeofApiCall<GetStationsT>;

      readonly createStation: TypeofApiCall<CreateStationT>;

      readonly getStationsCSV: TypeofApiCall<GetStationsCSVT>;

      readonly deleteStation: TypeofApiCall<DeleteStationT>;

      readonly getStation: TypeofApiCall<GetStationT>;

      readonly updateStation: TypeofApiCall<UpdateStationT>;

      readonly getStationCreditorInstitutions: TypeofApiCall<
        GetStationCreditorInstitutionsT
      >;

      readonly getStationCreditorInstitutionsCSV: TypeofApiCall<
        GetStationCreditorInstitutionsCSVT
      >;

      readonly getStationCreditorInstitutionRelation: TypeofApiCall<
        GetStationCreditorInstitutionRelationT
      >;
    }
  : {
      readonly manageCIStationRelationship: TypeofApiCall<
        ReplaceRequestParams<
          ManageCIStationRelationshipT,
          Omit<RequestParams<ManageCIStationRelationshipT>, K>
        >
      >;

      readonly massiveMigration: TypeofApiCall<
        ReplaceRequestParams<
          MassiveMigrationT,
          Omit<RequestParams<MassiveMigrationT>, K>
        >
      >;

      readonly getBrokers: TypeofApiCall<
        ReplaceRequestParams<GetBrokersT, Omit<RequestParams<GetBrokersT>, K>>
      >;

      readonly createBroker: TypeofApiCall<
        ReplaceRequestParams<
          CreateBrokerT,
          Omit<RequestParams<CreateBrokerT>, K>
        >
      >;

      readonly getAllStationsMaintenances: TypeofApiCall<
        ReplaceRequestParams<
          GetAllStationsMaintenancesT,
          Omit<RequestParams<GetAllStationsMaintenancesT>, K>
        >
      >;

      readonly deleteBroker: TypeofApiCall<
        ReplaceRequestParams<
          DeleteBrokerT,
          Omit<RequestParams<DeleteBrokerT>, K>
        >
      >;

      readonly getBroker: TypeofApiCall<
        ReplaceRequestParams<GetBrokerT, Omit<RequestParams<GetBrokerT>, K>>
      >;

      readonly updateBroker: TypeofApiCall<
        ReplaceRequestParams<
          UpdateBrokerT,
          Omit<RequestParams<UpdateBrokerT>, K>
        >
      >;

      readonly getStationMaintenances: TypeofApiCall<
        ReplaceRequestParams<
          GetStationMaintenancesT,
          Omit<RequestParams<GetStationMaintenancesT>, K>
        >
      >;

      readonly createStationMaintenance: TypeofApiCall<
        ReplaceRequestParams<
          CreateStationMaintenanceT,
          Omit<RequestParams<CreateStationMaintenanceT>, K>
        >
      >;

      readonly getBrokerMaintenancesSummary: TypeofApiCall<
        ReplaceRequestParams<
          GetBrokerMaintenancesSummaryT,
          Omit<RequestParams<GetBrokerMaintenancesSummaryT>, K>
        >
      >;

      readonly deleteStationMaintenance: TypeofApiCall<
        ReplaceRequestParams<
          DeleteStationMaintenanceT,
          Omit<RequestParams<DeleteStationMaintenanceT>, K>
        >
      >;

      readonly getStationMaintenance: TypeofApiCall<
        ReplaceRequestParams<
          GetStationMaintenanceT,
          Omit<RequestParams<GetStationMaintenanceT>, K>
        >
      >;

      readonly updateStationMaintenance: TypeofApiCall<
        ReplaceRequestParams<
          UpdateStationMaintenanceT,
          Omit<RequestParams<UpdateStationMaintenanceT>, K>
        >
      >;

      readonly getBrokersPsp: TypeofApiCall<
        ReplaceRequestParams<
          GetBrokersPspT,
          Omit<RequestParams<GetBrokersPspT>, K>
        >
      >;

      readonly createBrokerPsp: TypeofApiCall<
        ReplaceRequestParams<
          CreateBrokerPspT,
          Omit<RequestParams<CreateBrokerPspT>, K>
        >
      >;

      readonly deleteBrokerPsp: TypeofApiCall<
        ReplaceRequestParams<
          DeleteBrokerPspT,
          Omit<RequestParams<DeleteBrokerPspT>, K>
        >
      >;

      readonly getBrokerPsp: TypeofApiCall<
        ReplaceRequestParams<
          GetBrokerPspT,
          Omit<RequestParams<GetBrokerPspT>, K>
        >
      >;

      readonly updateBrokerPsp: TypeofApiCall<
        ReplaceRequestParams<
          UpdateBrokerPspT,
          Omit<RequestParams<UpdateBrokerPspT>, K>
        >
      >;

      readonly getPspBrokerPsp: TypeofApiCall<
        ReplaceRequestParams<
          GetPspBrokerPspT,
          Omit<RequestParams<GetPspBrokerPspT>, K>
        >
      >;

      readonly getCacheVersions: TypeofApiCall<
        ReplaceRequestParams<
          GetCacheVersionsT,
          Omit<RequestParams<GetCacheVersionsT>, K>
        >
      >;

      readonly getCacheByVersion: TypeofApiCall<
        ReplaceRequestParams<
          GetCacheByVersionT,
          Omit<RequestParams<GetCacheByVersionT>, K>
        >
      >;

      readonly getCacheId: TypeofApiCall<
        ReplaceRequestParams<GetCacheIdT, Omit<RequestParams<GetCacheIdT>, K>>
      >;

      readonly getCdis: TypeofApiCall<
        ReplaceRequestParams<GetCdisT, Omit<RequestParams<GetCdisT>, K>>
      >;

      readonly createCdi: TypeofApiCall<
        ReplaceRequestParams<CreateCdiT, Omit<RequestParams<CreateCdiT>, K>>
      >;

      readonly verifyCdi: TypeofApiCall<
        ReplaceRequestParams<VerifyCdiT, Omit<RequestParams<VerifyCdiT>, K>>
      >;

      readonly uploadHistory_1: TypeofApiCall<
        ReplaceRequestParams<
          UploadHistory_1T,
          Omit<RequestParams<UploadHistory_1T>, K>
        >
      >;

      readonly deleteCdi: TypeofApiCall<
        ReplaceRequestParams<DeleteCdiT, Omit<RequestParams<DeleteCdiT>, K>>
      >;

      readonly getCdi: TypeofApiCall<
        ReplaceRequestParams<GetCdiT, Omit<RequestParams<GetCdiT>, K>>
      >;

      readonly getCdsServices: TypeofApiCall<
        ReplaceRequestParams<
          GetCdsServicesT,
          Omit<RequestParams<GetCdsServicesT>, K>
        >
      >;

      readonly createCdsService: TypeofApiCall<
        ReplaceRequestParams<
          CreateCdsServiceT,
          Omit<RequestParams<CreateCdsServiceT>, K>
        >
      >;

      readonly deleteCdsService: TypeofApiCall<
        ReplaceRequestParams<
          DeleteCdsServiceT,
          Omit<RequestParams<DeleteCdsServiceT>, K>
        >
      >;

      readonly getCdsService: TypeofApiCall<
        ReplaceRequestParams<
          GetCdsServiceT,
          Omit<RequestParams<GetCdsServiceT>, K>
        >
      >;

      readonly updateCdsService: TypeofApiCall<
        ReplaceRequestParams<
          UpdateCdsServiceT,
          Omit<RequestParams<UpdateCdsServiceT>, K>
        >
      >;

      readonly getCdsSubjects: TypeofApiCall<
        ReplaceRequestParams<
          GetCdsSubjectsT,
          Omit<RequestParams<GetCdsSubjectsT>, K>
        >
      >;

      readonly createCdsSubject: TypeofApiCall<
        ReplaceRequestParams<
          CreateCdsSubjectT,
          Omit<RequestParams<CreateCdsSubjectT>, K>
        >
      >;

      readonly deleteCdsSubject: TypeofApiCall<
        ReplaceRequestParams<
          DeleteCdsSubjectT,
          Omit<RequestParams<DeleteCdsSubjectT>, K>
        >
      >;

      readonly getCdsSubject: TypeofApiCall<
        ReplaceRequestParams<
          GetCdsSubjectT,
          Omit<RequestParams<GetCdsSubjectT>, K>
        >
      >;

      readonly updateCdsSubject: TypeofApiCall<
        ReplaceRequestParams<
          UpdateCdsSubjectT,
          Omit<RequestParams<UpdateCdsSubjectT>, K>
        >
      >;

      readonly getCdsSubjectServices: TypeofApiCall<
        ReplaceRequestParams<
          GetCdsSubjectServicesT,
          Omit<RequestParams<GetCdsSubjectServicesT>, K>
        >
      >;

      readonly createCdsSubjectService: TypeofApiCall<
        ReplaceRequestParams<
          CreateCdsSubjectServiceT,
          Omit<RequestParams<CreateCdsSubjectServiceT>, K>
        >
      >;

      readonly deleteCdsSubjectService: TypeofApiCall<
        ReplaceRequestParams<
          DeleteCdsSubjectServiceT,
          Omit<RequestParams<DeleteCdsSubjectServiceT>, K>
        >
      >;

      readonly getCdsSubjectService: TypeofApiCall<
        ReplaceRequestParams<
          GetCdsSubjectServiceT,
          Omit<RequestParams<GetCdsSubjectServiceT>, K>
        >
      >;

      readonly updateCdsSubjectService: TypeofApiCall<
        ReplaceRequestParams<
          UpdateCdsSubjectServiceT,
          Omit<RequestParams<UpdateCdsSubjectServiceT>, K>
        >
      >;

      readonly getChannels: TypeofApiCall<
        ReplaceRequestParams<GetChannelsT, Omit<RequestParams<GetChannelsT>, K>>
      >;

      readonly createChannel: TypeofApiCall<
        ReplaceRequestParams<
          CreateChannelT,
          Omit<RequestParams<CreateChannelT>, K>
        >
      >;

      readonly getChannelsCSV: TypeofApiCall<
        ReplaceRequestParams<
          GetChannelsCSVT,
          Omit<RequestParams<GetChannelsCSVT>, K>
        >
      >;

      readonly deleteChannel: TypeofApiCall<
        ReplaceRequestParams<
          DeleteChannelT,
          Omit<RequestParams<DeleteChannelT>, K>
        >
      >;

      readonly getChannel: TypeofApiCall<
        ReplaceRequestParams<GetChannelT, Omit<RequestParams<GetChannelT>, K>>
      >;

      readonly updateChannel: TypeofApiCall<
        ReplaceRequestParams<
          UpdateChannelT,
          Omit<RequestParams<UpdateChannelT>, K>
        >
      >;

      readonly getChannelPaymentServiceProviders: TypeofApiCall<
        ReplaceRequestParams<
          GetChannelPaymentServiceProvidersT,
          Omit<RequestParams<GetChannelPaymentServiceProvidersT>, K>
        >
      >;

      readonly getChannelPaymentServiceProvidersCSV: TypeofApiCall<
        ReplaceRequestParams<
          GetChannelPaymentServiceProvidersCSVT,
          Omit<RequestParams<GetChannelPaymentServiceProvidersCSVT>, K>
        >
      >;

      readonly getChannelPaymentTypes: TypeofApiCall<
        ReplaceRequestParams<
          GetChannelPaymentTypesT,
          Omit<RequestParams<GetChannelPaymentTypesT>, K>
        >
      >;

      readonly createChannelPaymentType: TypeofApiCall<
        ReplaceRequestParams<
          CreateChannelPaymentTypeT,
          Omit<RequestParams<CreateChannelPaymentTypeT>, K>
        >
      >;

      readonly deleteChannelPaymentType: TypeofApiCall<
        ReplaceRequestParams<
          DeleteChannelPaymentTypeT,
          Omit<RequestParams<DeleteChannelPaymentTypeT>, K>
        >
      >;

      readonly getFtpServers: TypeofApiCall<
        ReplaceRequestParams<
          GetFtpServersT,
          Omit<RequestParams<GetFtpServersT>, K>
        >
      >;

      readonly createFtpServer: TypeofApiCall<
        ReplaceRequestParams<
          CreateFtpServerT,
          Omit<RequestParams<CreateFtpServerT>, K>
        >
      >;

      readonly deleteFtpServer: TypeofApiCall<
        ReplaceRequestParams<
          DeleteFtpServerT,
          Omit<RequestParams<DeleteFtpServerT>, K>
        >
      >;

      readonly getFtpServer: TypeofApiCall<
        ReplaceRequestParams<
          GetFtpServerT,
          Omit<RequestParams<GetFtpServerT>, K>
        >
      >;

      readonly updateFtpServer: TypeofApiCall<
        ReplaceRequestParams<
          UpdateFtpServerT,
          Omit<RequestParams<UpdateFtpServerT>, K>
        >
      >;

      readonly getConfigurationKeys: TypeofApiCall<
        ReplaceRequestParams<
          GetConfigurationKeysT,
          Omit<RequestParams<GetConfigurationKeysT>, K>
        >
      >;

      readonly createConfigurationKey: TypeofApiCall<
        ReplaceRequestParams<
          CreateConfigurationKeyT,
          Omit<RequestParams<CreateConfigurationKeyT>, K>
        >
      >;

      readonly deleteConfigurationKey: TypeofApiCall<
        ReplaceRequestParams<
          DeleteConfigurationKeyT,
          Omit<RequestParams<DeleteConfigurationKeyT>, K>
        >
      >;

      readonly getConfigurationKey: TypeofApiCall<
        ReplaceRequestParams<
          GetConfigurationKeyT,
          Omit<RequestParams<GetConfigurationKeyT>, K>
        >
      >;

      readonly updateConfigurationKey: TypeofApiCall<
        ReplaceRequestParams<
          UpdateConfigurationKeyT,
          Omit<RequestParams<UpdateConfigurationKeyT>, K>
        >
      >;

      readonly getPaymentTypes: TypeofApiCall<
        ReplaceRequestParams<
          GetPaymentTypesT,
          Omit<RequestParams<GetPaymentTypesT>, K>
        >
      >;

      readonly createPaymentType: TypeofApiCall<
        ReplaceRequestParams<
          CreatePaymentTypeT,
          Omit<RequestParams<CreatePaymentTypeT>, K>
        >
      >;

      readonly uploadHistory: TypeofApiCall<
        ReplaceRequestParams<
          UploadHistoryT,
          Omit<RequestParams<UploadHistoryT>, K>
        >
      >;

      readonly deletePaymentType: TypeofApiCall<
        ReplaceRequestParams<
          DeletePaymentTypeT,
          Omit<RequestParams<DeletePaymentTypeT>, K>
        >
      >;

      readonly getPaymentType: TypeofApiCall<
        ReplaceRequestParams<
          GetPaymentTypeT,
          Omit<RequestParams<GetPaymentTypeT>, K>
        >
      >;

      readonly updatePaymentType: TypeofApiCall<
        ReplaceRequestParams<
          UpdatePaymentTypeT,
          Omit<RequestParams<UpdatePaymentTypeT>, K>
        >
      >;

      readonly getPdds: TypeofApiCall<
        ReplaceRequestParams<GetPddsT, Omit<RequestParams<GetPddsT>, K>>
      >;

      readonly createPdd: TypeofApiCall<
        ReplaceRequestParams<CreatePddT, Omit<RequestParams<CreatePddT>, K>>
      >;

      readonly deletePdd: TypeofApiCall<
        ReplaceRequestParams<DeletePddT, Omit<RequestParams<DeletePddT>, K>>
      >;

      readonly getPdd: TypeofApiCall<
        ReplaceRequestParams<GetPddT, Omit<RequestParams<GetPddT>, K>>
      >;

      readonly updatePdd: TypeofApiCall<
        ReplaceRequestParams<UpdatePddT, Omit<RequestParams<UpdatePddT>, K>>
      >;

      readonly getWfespPlugins: TypeofApiCall<
        ReplaceRequestParams<
          GetWfespPluginsT,
          Omit<RequestParams<GetWfespPluginsT>, K>
        >
      >;

      readonly createWfespPlugin: TypeofApiCall<
        ReplaceRequestParams<
          CreateWfespPluginT,
          Omit<RequestParams<CreateWfespPluginT>, K>
        >
      >;

      readonly deleteWfespPlugin: TypeofApiCall<
        ReplaceRequestParams<
          DeleteWfespPluginT,
          Omit<RequestParams<DeleteWfespPluginT>, K>
        >
      >;

      readonly getWfespPlugin: TypeofApiCall<
        ReplaceRequestParams<
          GetWfespPluginT,
          Omit<RequestParams<GetWfespPluginT>, K>
        >
      >;

      readonly updateWfespPlugin: TypeofApiCall<
        ReplaceRequestParams<
          UpdateWfespPluginT,
          Omit<RequestParams<UpdateWfespPluginT>, K>
        >
      >;

      readonly getCounterpartTables: TypeofApiCall<
        ReplaceRequestParams<
          GetCounterpartTablesT,
          Omit<RequestParams<GetCounterpartTablesT>, K>
        >
      >;

      readonly createCounterpartTable: TypeofApiCall<
        ReplaceRequestParams<
          CreateCounterpartTableT,
          Omit<RequestParams<CreateCounterpartTableT>, K>
        >
      >;

      readonly deleteCounterpartTable: TypeofApiCall<
        ReplaceRequestParams<
          DeleteCounterpartTableT,
          Omit<RequestParams<DeleteCounterpartTableT>, K>
        >
      >;

      readonly getCounterpartTable: TypeofApiCall<
        ReplaceRequestParams<
          GetCounterpartTableT,
          Omit<RequestParams<GetCounterpartTableT>, K>
        >
      >;

      readonly getCreditorInstitutions: TypeofApiCall<
        ReplaceRequestParams<
          GetCreditorInstitutionsT,
          Omit<RequestParams<GetCreditorInstitutionsT>, K>
        >
      >;

      readonly createCreditorInstitution: TypeofApiCall<
        ReplaceRequestParams<
          CreateCreditorInstitutionT,
          Omit<RequestParams<CreateCreditorInstitutionT>, K>
        >
      >;

      readonly massiveUploadCbillCsv: TypeofApiCall<
        ReplaceRequestParams<
          MassiveUploadCbillCsvT,
          Omit<RequestParams<MassiveUploadCbillCsvT>, K>
        >
      >;

      readonly massiveCreateIbans: TypeofApiCall<
        ReplaceRequestParams<
          MassiveCreateIbansT,
          Omit<RequestParams<MassiveCreateIbansT>, K>
        >
      >;

      readonly massiveCreateIbansCsv: TypeofApiCall<
        ReplaceRequestParams<
          MassiveCreateIbansCsvT,
          Omit<RequestParams<MassiveCreateIbansCsvT>, K>
        >
      >;

      readonly upsertIbanLabel: TypeofApiCall<
        ReplaceRequestParams<
          UpsertIbanLabelT,
          Omit<RequestParams<UpsertIbanLabelT>, K>
        >
      >;

      readonly getCreditorInstitutionsView: TypeofApiCall<
        ReplaceRequestParams<
          GetCreditorInstitutionsViewT,
          Omit<RequestParams<GetCreditorInstitutionsViewT>, K>
        >
      >;

      readonly deleteCreditorInstitution: TypeofApiCall<
        ReplaceRequestParams<
          DeleteCreditorInstitutionT,
          Omit<RequestParams<DeleteCreditorInstitutionT>, K>
        >
      >;

      readonly getCreditorInstitution: TypeofApiCall<
        ReplaceRequestParams<
          GetCreditorInstitutionT,
          Omit<RequestParams<GetCreditorInstitutionT>, K>
        >
      >;

      readonly updateCreditorInstitution: TypeofApiCall<
        ReplaceRequestParams<
          UpdateCreditorInstitutionT,
          Omit<RequestParams<UpdateCreditorInstitutionT>, K>
        >
      >;

      readonly getCreditorInstitutionEncodings: TypeofApiCall<
        ReplaceRequestParams<
          GetCreditorInstitutionEncodingsT,
          Omit<RequestParams<GetCreditorInstitutionEncodingsT>, K>
        >
      >;

      readonly createCreditorInstitutionEncoding: TypeofApiCall<
        ReplaceRequestParams<
          CreateCreditorInstitutionEncodingT,
          Omit<RequestParams<CreateCreditorInstitutionEncodingT>, K>
        >
      >;

      readonly deleteCreditorInstitutionEncoding: TypeofApiCall<
        ReplaceRequestParams<
          DeleteCreditorInstitutionEncodingT,
          Omit<RequestParams<DeleteCreditorInstitutionEncodingT>, K>
        >
      >;

      readonly getCreditorInstitutionsIbans: TypeofApiCall<
        ReplaceRequestParams<
          GetCreditorInstitutionsIbansT,
          Omit<RequestParams<GetCreditorInstitutionsIbansT>, K>
        >
      >;

      readonly createCreditorInstitutionsIbans: TypeofApiCall<
        ReplaceRequestParams<
          CreateCreditorInstitutionsIbansT,
          Omit<RequestParams<CreateCreditorInstitutionsIbansT>, K>
        >
      >;

      readonly getIbans: TypeofApiCall<
        ReplaceRequestParams<GetIbansT, Omit<RequestParams<GetIbansT>, K>>
      >;

      readonly updateCreditorInstitutionsIbans: TypeofApiCall<
        ReplaceRequestParams<
          UpdateCreditorInstitutionsIbansT,
          Omit<RequestParams<UpdateCreditorInstitutionsIbansT>, K>
        >
      >;

      readonly deleteCreditorInstitutionsIban: TypeofApiCall<
        ReplaceRequestParams<
          DeleteCreditorInstitutionsIbanT,
          Omit<RequestParams<DeleteCreditorInstitutionsIbanT>, K>
        >
      >;

      readonly getCreditorInstitutionStations: TypeofApiCall<
        ReplaceRequestParams<
          GetCreditorInstitutionStationsT,
          Omit<RequestParams<GetCreditorInstitutionStationsT>, K>
        >
      >;

      readonly createCreditorInstitutionStation: TypeofApiCall<
        ReplaceRequestParams<
          CreateCreditorInstitutionStationT,
          Omit<RequestParams<CreateCreditorInstitutionStationT>, K>
        >
      >;

      readonly deleteCreditorInstitutionStation: TypeofApiCall<
        ReplaceRequestParams<
          DeleteCreditorInstitutionStationT,
          Omit<RequestParams<DeleteCreditorInstitutionStationT>, K>
        >
      >;

      readonly updateCreditorInstitutionStation: TypeofApiCall<
        ReplaceRequestParams<
          UpdateCreditorInstitutionStationT,
          Omit<RequestParams<UpdateCreditorInstitutionStationT>, K>
        >
      >;

      readonly getCreditorInstitutionByPostalEncoding: TypeofApiCall<
        ReplaceRequestParams<
          GetCreditorInstitutionByPostalEncodingT,
          Omit<RequestParams<GetCreditorInstitutionByPostalEncodingT>, K>
        >
      >;

      readonly getCreditorInstitutionsByIban: TypeofApiCall<
        ReplaceRequestParams<
          GetCreditorInstitutionsByIbanT,
          Omit<RequestParams<GetCreditorInstitutionsByIbanT>, K>
        >
      >;

      readonly getIcas: TypeofApiCall<
        ReplaceRequestParams<GetIcasT, Omit<RequestParams<GetIcasT>, K>>
      >;

      readonly createIca: TypeofApiCall<
        ReplaceRequestParams<CreateIcaT, Omit<RequestParams<CreateIcaT>, K>>
      >;

      readonly verifyIca: TypeofApiCall<
        ReplaceRequestParams<VerifyIcaT, Omit<RequestParams<VerifyIcaT>, K>>
      >;

      readonly massiveVerifyIcas: TypeofApiCall<
        ReplaceRequestParams<
          MassiveVerifyIcasT,
          Omit<RequestParams<MassiveVerifyIcasT>, K>
        >
      >;

      readonly massiveCreateIcas: TypeofApiCall<
        ReplaceRequestParams<
          MassiveCreateIcasT,
          Omit<RequestParams<MassiveCreateIcasT>, K>
        >
      >;

      readonly checkXSD: TypeofApiCall<
        ReplaceRequestParams<CheckXSDT, Omit<RequestParams<CheckXSDT>, K>>
      >;

      readonly deleteIca: TypeofApiCall<
        ReplaceRequestParams<DeleteIcaT, Omit<RequestParams<DeleteIcaT>, K>>
      >;

      readonly getIca: TypeofApiCall<
        ReplaceRequestParams<GetIcaT, Omit<RequestParams<GetIcaT>, K>>
      >;

      readonly healthCheck: TypeofApiCall<
        ReplaceRequestParams<HealthCheckT, Omit<RequestParams<HealthCheckT>, K>>
      >;

      readonly getPaymentServiceProviders: TypeofApiCall<
        ReplaceRequestParams<
          GetPaymentServiceProvidersT,
          Omit<RequestParams<GetPaymentServiceProvidersT>, K>
        >
      >;

      readonly createPaymentServiceProvider: TypeofApiCall<
        ReplaceRequestParams<
          CreatePaymentServiceProviderT,
          Omit<RequestParams<CreatePaymentServiceProviderT>, K>
        >
      >;

      readonly getPaymentServiceProvidersView: TypeofApiCall<
        ReplaceRequestParams<
          GetPaymentServiceProvidersViewT,
          Omit<RequestParams<GetPaymentServiceProvidersViewT>, K>
        >
      >;

      readonly deletePaymentServiceProvider: TypeofApiCall<
        ReplaceRequestParams<
          DeletePaymentServiceProviderT,
          Omit<RequestParams<DeletePaymentServiceProviderT>, K>
        >
      >;

      readonly getPaymentServiceProvider: TypeofApiCall<
        ReplaceRequestParams<
          GetPaymentServiceProviderT,
          Omit<RequestParams<GetPaymentServiceProviderT>, K>
        >
      >;

      readonly updatePaymentServiceProvider: TypeofApiCall<
        ReplaceRequestParams<
          UpdatePaymentServiceProviderT,
          Omit<RequestParams<UpdatePaymentServiceProviderT>, K>
        >
      >;

      readonly getPaymentServiceProvidersChannels: TypeofApiCall<
        ReplaceRequestParams<
          GetPaymentServiceProvidersChannelsT,
          Omit<RequestParams<GetPaymentServiceProvidersChannelsT>, K>
        >
      >;

      readonly createPaymentServiceProvidersChannels: TypeofApiCall<
        ReplaceRequestParams<
          CreatePaymentServiceProvidersChannelsT,
          Omit<RequestParams<CreatePaymentServiceProvidersChannelsT>, K>
        >
      >;

      readonly deletePaymentServiceProvidersChannels: TypeofApiCall<
        ReplaceRequestParams<
          DeletePaymentServiceProvidersChannelsT,
          Omit<RequestParams<DeletePaymentServiceProvidersChannelsT>, K>
        >
      >;

      readonly updatePaymentServiceProvidersChannels: TypeofApiCall<
        ReplaceRequestParams<
          UpdatePaymentServiceProvidersChannelsT,
          Omit<RequestParams<UpdatePaymentServiceProvidersChannelsT>, K>
        >
      >;

      readonly getRefreshGlobalConfig: TypeofApiCall<
        ReplaceRequestParams<
          GetRefreshGlobalConfigT,
          Omit<RequestParams<GetRefreshGlobalConfigT>, K>
        >
      >;

      readonly getJobTrigger: TypeofApiCall<
        ReplaceRequestParams<
          GetJobTriggerT,
          Omit<RequestParams<GetJobTriggerT>, K>
        >
      >;

      readonly getServices: TypeofApiCall<
        ReplaceRequestParams<GetServicesT, Omit<RequestParams<GetServicesT>, K>>
      >;

      readonly getStations: TypeofApiCall<
        ReplaceRequestParams<GetStationsT, Omit<RequestParams<GetStationsT>, K>>
      >;

      readonly createStation: TypeofApiCall<
        ReplaceRequestParams<
          CreateStationT,
          Omit<RequestParams<CreateStationT>, K>
        >
      >;

      readonly getStationsCSV: TypeofApiCall<
        ReplaceRequestParams<
          GetStationsCSVT,
          Omit<RequestParams<GetStationsCSVT>, K>
        >
      >;

      readonly deleteStation: TypeofApiCall<
        ReplaceRequestParams<
          DeleteStationT,
          Omit<RequestParams<DeleteStationT>, K>
        >
      >;

      readonly getStation: TypeofApiCall<
        ReplaceRequestParams<GetStationT, Omit<RequestParams<GetStationT>, K>>
      >;

      readonly updateStation: TypeofApiCall<
        ReplaceRequestParams<
          UpdateStationT,
          Omit<RequestParams<UpdateStationT>, K>
        >
      >;

      readonly getStationCreditorInstitutions: TypeofApiCall<
        ReplaceRequestParams<
          GetStationCreditorInstitutionsT,
          Omit<RequestParams<GetStationCreditorInstitutionsT>, K>
        >
      >;

      readonly getStationCreditorInstitutionsCSV: TypeofApiCall<
        ReplaceRequestParams<
          GetStationCreditorInstitutionsCSVT,
          Omit<RequestParams<GetStationCreditorInstitutionsCSVT>, K>
        >
      >;

      readonly getStationCreditorInstitutionRelation: TypeofApiCall<
        ReplaceRequestParams<
          GetStationCreditorInstitutionRelationT,
          Omit<RequestParams<GetStationCreditorInstitutionRelationT>, K>
        >
      >;
    };

/**
 * Create an instance of a client
 * @param params hash map of parameters thata define the client:
 *  - baseUrl: the base url for every api call (required)
 *  - fetchApi: an implementation of the fetch() web API, depending on the platform (required)
 *  - basePath: optional path to be appended to the baseUrl
 *  - withDefaults: optional adapter to be applied to every operation, to omit some paramenters
 * @returns a collection of api operations
 */
export function createClient<K extends ParamKeys>(params: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults: WithDefaultsT<K>;
  basePath?: string;
}): Client<K>;
export function createClient(params: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults?: undefined;
  basePath?: string;
}): Client;
export function createClient<K extends ParamKeys>({
  baseUrl,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi,
  withDefaults,
  basePath = "/"
}: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults?: WithDefaultsT<K>;
  basePath?: string;
}) {
  const options = {
    baseUrl,
    fetchApi
  };

  const manageCIStationRelationshipT: ReplaceRequestParams<
    ManageCIStationRelationshipT,
    RequestParams<ManageCIStationRelationshipT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "multipart/form-data"
    }),
    response_decoder: manageCIStationRelationshipDefaultDecoder(),
    url: ({}) =>
      `${basePath}/batchoperation/creditorinstitution-station/loading`,

    body: ({ ["file"]: file }) => file.uri,

    query: () => withoutUndefinedValues({})
  };
  const manageCIStationRelationship: TypeofApiCall<ManageCIStationRelationshipT> = createFetchRequestForApi(
    manageCIStationRelationshipT,
    options
  );

  const massiveMigrationT: ReplaceRequestParams<
    MassiveMigrationT,
    RequestParams<MassiveMigrationT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "multipart/form-data"
    }),
    response_decoder: massiveMigrationDefaultDecoder(),
    url: ({}) =>
      `${basePath}/batchoperation/creditorinstitution-station/migration`,

    body: ({ ["file"]: file }) => file.uri,

    query: () => withoutUndefinedValues({})
  };
  const massiveMigration: TypeofApiCall<MassiveMigrationT> = createFetchRequestForApi(
    massiveMigrationT,
    options
  );

  const getBrokersT: ReplaceRequestParams<
    GetBrokersT,
    RequestParams<GetBrokersT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getBrokersDefaultDecoder(),
    url: ({}) => `${basePath}/brokers`,

    query: ({
      ["limit"]: limit,
      ["page"]: page,
      ["code"]: code,
      ["name"]: name,
      ["orderby"]: orderby,
      ["ordering"]: ordering
    }) =>
      withoutUndefinedValues({
        ["limit"]: limit,
        ["page"]: page,
        ["code"]: code,
        ["name"]: name,
        ["orderby"]: orderby,
        ["ordering"]: ordering
      })
  };
  const getBrokers: TypeofApiCall<GetBrokersT> = createFetchRequestForApi(
    getBrokersT,
    options
  );

  const createBrokerT: ReplaceRequestParams<
    CreateBrokerT,
    RequestParams<CreateBrokerT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createBrokerDefaultDecoder(),
    url: ({}) => `${basePath}/brokers`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createBroker: TypeofApiCall<CreateBrokerT> = createFetchRequestForApi(
    createBrokerT,
    options
  );

  const getAllStationsMaintenancesT: ReplaceRequestParams<
    GetAllStationsMaintenancesT,
    RequestParams<GetAllStationsMaintenancesT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getAllStationsMaintenancesDefaultDecoder(),
    url: ({}) => `${basePath}/brokers/station-maintenances`,

    query: ({
      ["startDateTimeBefore"]: startDateTimeBefore,
      ["startDateTimeAfter"]: startDateTimeAfter,
      ["endDateTimeBefore"]: endDateTimeBefore,
      ["endDateTimeAfter"]: endDateTimeAfter
    }) =>
      withoutUndefinedValues({
        ["startDateTimeBefore"]: startDateTimeBefore,
        ["startDateTimeAfter"]: startDateTimeAfter,
        ["endDateTimeBefore"]: endDateTimeBefore,
        ["endDateTimeAfter"]: endDateTimeAfter
      })
  };
  const getAllStationsMaintenances: TypeofApiCall<GetAllStationsMaintenancesT> = createFetchRequestForApi(
    getAllStationsMaintenancesT,
    options
  );

  const deleteBrokerT: ReplaceRequestParams<
    DeleteBrokerT,
    RequestParams<DeleteBrokerT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteBrokerDefaultDecoder(),
    url: ({ ["brokercode"]: brokercode }) =>
      `${basePath}/brokers/${brokercode}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteBroker: TypeofApiCall<DeleteBrokerT> = createFetchRequestForApi(
    deleteBrokerT,
    options
  );

  const getBrokerT: ReplaceRequestParams<
    GetBrokerT,
    RequestParams<GetBrokerT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getBrokerDefaultDecoder(),
    url: ({ ["brokercode"]: brokercode }) =>
      `${basePath}/brokers/${brokercode}`,

    query: () => withoutUndefinedValues({})
  };
  const getBroker: TypeofApiCall<GetBrokerT> = createFetchRequestForApi(
    getBrokerT,
    options
  );

  const updateBrokerT: ReplaceRequestParams<
    UpdateBrokerT,
    RequestParams<UpdateBrokerT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateBrokerDefaultDecoder(),
    url: ({ ["brokercode"]: brokercode }) =>
      `${basePath}/brokers/${brokercode}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateBroker: TypeofApiCall<UpdateBrokerT> = createFetchRequestForApi(
    updateBrokerT,
    options
  );

  const getStationMaintenancesT: ReplaceRequestParams<
    GetStationMaintenancesT,
    RequestParams<GetStationMaintenancesT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getStationMaintenancesDefaultDecoder(),
    url: ({ ["brokercode"]: brokercode }) =>
      `${basePath}/brokers/${brokercode}/station-maintenances`,

    query: ({
      ["stationCode"]: stationCode,
      ["startDateTimeBefore"]: startDateTimeBefore,
      ["startDateTimeAfter"]: startDateTimeAfter,
      ["endDateTimeBefore"]: endDateTimeBefore,
      ["endDateTimeAfter"]: endDateTimeAfter,
      ["limit"]: limit,
      ["page"]: page
    }) =>
      withoutUndefinedValues({
        ["stationCode"]: stationCode,
        ["startDateTimeBefore"]: startDateTimeBefore,
        ["startDateTimeAfter"]: startDateTimeAfter,
        ["endDateTimeBefore"]: endDateTimeBefore,
        ["endDateTimeAfter"]: endDateTimeAfter,
        ["limit"]: limit,
        ["page"]: page
      })
  };
  const getStationMaintenances: TypeofApiCall<GetStationMaintenancesT> = createFetchRequestForApi(
    getStationMaintenancesT,
    options
  );

  const createStationMaintenanceT: ReplaceRequestParams<
    CreateStationMaintenanceT,
    RequestParams<CreateStationMaintenanceT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createStationMaintenanceDefaultDecoder(),
    url: ({ ["brokercode"]: brokercode }) =>
      `${basePath}/brokers/${brokercode}/station-maintenances`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createStationMaintenance: TypeofApiCall<CreateStationMaintenanceT> = createFetchRequestForApi(
    createStationMaintenanceT,
    options
  );

  const getBrokerMaintenancesSummaryT: ReplaceRequestParams<
    GetBrokerMaintenancesSummaryT,
    RequestParams<GetBrokerMaintenancesSummaryT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getBrokerMaintenancesSummaryDefaultDecoder(),
    url: ({ ["brokercode"]: brokercode }) =>
      `${basePath}/brokers/${brokercode}/station-maintenances/summary`,

    query: ({ ["maintenanceYear"]: maintenanceYear }) =>
      withoutUndefinedValues({ ["maintenanceYear"]: maintenanceYear })
  };
  const getBrokerMaintenancesSummary: TypeofApiCall<GetBrokerMaintenancesSummaryT> = createFetchRequestForApi(
    getBrokerMaintenancesSummaryT,
    options
  );

  const deleteStationMaintenanceT: ReplaceRequestParams<
    DeleteStationMaintenanceT,
    RequestParams<DeleteStationMaintenanceT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteStationMaintenanceDefaultDecoder(),
    url: ({ ["brokercode"]: brokercode, ["maintenanceid"]: maintenanceid }) =>
      `${basePath}/brokers/${brokercode}/station-maintenances/${maintenanceid}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteStationMaintenance: TypeofApiCall<DeleteStationMaintenanceT> = createFetchRequestForApi(
    deleteStationMaintenanceT,
    options
  );

  const getStationMaintenanceT: ReplaceRequestParams<
    GetStationMaintenanceT,
    RequestParams<GetStationMaintenanceT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getStationMaintenanceDefaultDecoder(),
    url: ({ ["brokercode"]: brokercode, ["maintenanceid"]: maintenanceid }) =>
      `${basePath}/brokers/${brokercode}/station-maintenances/${maintenanceid}`,

    query: () => withoutUndefinedValues({})
  };
  const getStationMaintenance: TypeofApiCall<GetStationMaintenanceT> = createFetchRequestForApi(
    getStationMaintenanceT,
    options
  );

  const updateStationMaintenanceT: ReplaceRequestParams<
    UpdateStationMaintenanceT,
    RequestParams<UpdateStationMaintenanceT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateStationMaintenanceDefaultDecoder(),
    url: ({ ["brokercode"]: brokercode, ["maintenanceid"]: maintenanceid }) =>
      `${basePath}/brokers/${brokercode}/station-maintenances/${maintenanceid}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateStationMaintenance: TypeofApiCall<UpdateStationMaintenanceT> = createFetchRequestForApi(
    updateStationMaintenanceT,
    options
  );

  const getBrokersPspT: ReplaceRequestParams<
    GetBrokersPspT,
    RequestParams<GetBrokersPspT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getBrokersPspDefaultDecoder(),
    url: ({}) => `${basePath}/brokerspsp`,

    query: ({
      ["limit"]: limit,
      ["page"]: page,
      ["code"]: code,
      ["name"]: name,
      ["orderby"]: orderby,
      ["ordering"]: ordering
    }) =>
      withoutUndefinedValues({
        ["limit"]: limit,
        ["page"]: page,
        ["code"]: code,
        ["name"]: name,
        ["orderby"]: orderby,
        ["ordering"]: ordering
      })
  };
  const getBrokersPsp: TypeofApiCall<GetBrokersPspT> = createFetchRequestForApi(
    getBrokersPspT,
    options
  );

  const createBrokerPspT: ReplaceRequestParams<
    CreateBrokerPspT,
    RequestParams<CreateBrokerPspT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createBrokerPspDefaultDecoder(),
    url: ({}) => `${basePath}/brokerspsp`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createBrokerPsp: TypeofApiCall<CreateBrokerPspT> = createFetchRequestForApi(
    createBrokerPspT,
    options
  );

  const deleteBrokerPspT: ReplaceRequestParams<
    DeleteBrokerPspT,
    RequestParams<DeleteBrokerPspT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteBrokerPspDefaultDecoder(),
    url: ({ ["brokerpspcode"]: brokerpspcode }) =>
      `${basePath}/brokerspsp/${brokerpspcode}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteBrokerPsp: TypeofApiCall<DeleteBrokerPspT> = createFetchRequestForApi(
    deleteBrokerPspT,
    options
  );

  const getBrokerPspT: ReplaceRequestParams<
    GetBrokerPspT,
    RequestParams<GetBrokerPspT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getBrokerPspDefaultDecoder(),
    url: ({ ["brokerpspcode"]: brokerpspcode }) =>
      `${basePath}/brokerspsp/${brokerpspcode}`,

    query: () => withoutUndefinedValues({})
  };
  const getBrokerPsp: TypeofApiCall<GetBrokerPspT> = createFetchRequestForApi(
    getBrokerPspT,
    options
  );

  const updateBrokerPspT: ReplaceRequestParams<
    UpdateBrokerPspT,
    RequestParams<UpdateBrokerPspT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateBrokerPspDefaultDecoder(),
    url: ({ ["brokerpspcode"]: brokerpspcode }) =>
      `${basePath}/brokerspsp/${brokerpspcode}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateBrokerPsp: TypeofApiCall<UpdateBrokerPspT> = createFetchRequestForApi(
    updateBrokerPspT,
    options
  );

  const getPspBrokerPspT: ReplaceRequestParams<
    GetPspBrokerPspT,
    RequestParams<GetPspBrokerPspT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getPspBrokerPspDefaultDecoder(),
    url: ({ ["brokerpspcode"]: brokerpspcode }) =>
      `${basePath}/brokerspsp/${brokerpspcode}/paymentserviceproviders`,

    query: ({ ["limit"]: limit, ["page"]: page }) =>
      withoutUndefinedValues({ ["limit"]: limit, ["page"]: page })
  };
  const getPspBrokerPsp: TypeofApiCall<GetPspBrokerPspT> = createFetchRequestForApi(
    getPspBrokerPspT,
    options
  );

  const getCacheVersionsT: ReplaceRequestParams<
    GetCacheVersionsT,
    RequestParams<GetCacheVersionsT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCacheVersionsDefaultDecoder(),
    url: ({}) => `${basePath}/cache/versions`,

    query: ({ ["limit"]: limit, ["page"]: page }) =>
      withoutUndefinedValues({ ["limit"]: limit, ["page"]: page })
  };
  const getCacheVersions: TypeofApiCall<GetCacheVersionsT> = createFetchRequestForApi(
    getCacheVersionsT,
    options
  );

  const getCacheByVersionT: ReplaceRequestParams<
    GetCacheByVersionT,
    RequestParams<GetCacheByVersionT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCacheByVersionDefaultDecoder(),
    url: ({ ["version"]: version }) => `${basePath}/cache/versions/${version}`,

    query: () => withoutUndefinedValues({})
  };
  const getCacheByVersion: TypeofApiCall<GetCacheByVersionT> = createFetchRequestForApi(
    getCacheByVersionT,
    options
  );

  const getCacheIdT: ReplaceRequestParams<
    GetCacheIdT,
    RequestParams<GetCacheIdT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCacheIdDefaultDecoder(),
    url: ({ ["version"]: version }) =>
      `${basePath}/cache/versions/${version}/id`,

    query: () => withoutUndefinedValues({})
  };
  const getCacheId: TypeofApiCall<GetCacheIdT> = createFetchRequestForApi(
    getCacheIdT,
    options
  );

  const getCdisT: ReplaceRequestParams<GetCdisT, RequestParams<GetCdisT>> = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCdisDefaultDecoder(),
    url: ({}) => `${basePath}/cdis`,

    query: ({
      ["limit"]: limit,
      ["page"]: page,
      ["idcdi"]: idcdi,
      ["pspcode"]: pspcode
    }) =>
      withoutUndefinedValues({
        ["limit"]: limit,
        ["page"]: page,
        ["idcdi"]: idcdi,
        ["pspcode"]: pspcode
      })
  };
  const getCdis: TypeofApiCall<GetCdisT> = createFetchRequestForApi(
    getCdisT,
    options
  );

  const createCdiT: ReplaceRequestParams<
    CreateCdiT,
    RequestParams<CreateCdiT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "multipart/form-data"
    }),
    response_decoder: createCdiDefaultDecoder(),
    url: ({}) => `${basePath}/cdis`,

    body: ({ ["file"]: file }) => file.uri,

    query: () => withoutUndefinedValues({})
  };
  const createCdi: TypeofApiCall<CreateCdiT> = createFetchRequestForApi(
    createCdiT,
    options
  );

  const verifyCdiT: ReplaceRequestParams<
    VerifyCdiT,
    RequestParams<VerifyCdiT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "multipart/form-data"
    }),
    response_decoder: verifyCdiDefaultDecoder(),
    url: ({}) => `${basePath}/cdis/check`,

    body: ({ ["file"]: file }) => file.uri,

    query: () => withoutUndefinedValues({})
  };
  const verifyCdi: TypeofApiCall<VerifyCdiT> = createFetchRequestForApi(
    verifyCdiT,
    options
  );

  const uploadHistory_1T: ReplaceRequestParams<
    UploadHistory_1T,
    RequestParams<UploadHistory_1T>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: uploadHistory_1DefaultDecoder(),
    url: ({}) => `${basePath}/cdis/history`,

    query: () => withoutUndefinedValues({})
  };
  const uploadHistory_1: TypeofApiCall<UploadHistory_1T> = createFetchRequestForApi(
    uploadHistory_1T,
    options
  );

  const deleteCdiT: ReplaceRequestParams<
    DeleteCdiT,
    RequestParams<DeleteCdiT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteCdiDefaultDecoder(),
    url: ({ ["idcdi"]: idcdi }) => `${basePath}/cdis/${idcdi}`,

    query: ({ ["pspcode"]: pspcode }) =>
      withoutUndefinedValues({ ["pspcode"]: pspcode })
  };
  const deleteCdi: TypeofApiCall<DeleteCdiT> = createFetchRequestForApi(
    deleteCdiT,
    options
  );

  const getCdiT: ReplaceRequestParams<GetCdiT, RequestParams<GetCdiT>> = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCdiDefaultDecoder(),
    url: ({ ["idcdi"]: idcdi }) => `${basePath}/cdis/${idcdi}`,

    query: ({ ["pspcode"]: pspcode }) =>
      withoutUndefinedValues({ ["pspcode"]: pspcode })
  };
  const getCdi: TypeofApiCall<GetCdiT> = createFetchRequestForApi(
    getCdiT,
    options
  );

  const getCdsServicesT: ReplaceRequestParams<
    GetCdsServicesT,
    RequestParams<GetCdsServicesT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCdsServicesDefaultDecoder(),
    url: ({}) => `${basePath}/cds/services`,

    query: () => withoutUndefinedValues({})
  };
  const getCdsServices: TypeofApiCall<GetCdsServicesT> = createFetchRequestForApi(
    getCdsServicesT,
    options
  );

  const createCdsServiceT: ReplaceRequestParams<
    CreateCdsServiceT,
    RequestParams<CreateCdsServiceT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createCdsServiceDefaultDecoder(),
    url: ({}) => `${basePath}/cds/services`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createCdsService: TypeofApiCall<CreateCdsServiceT> = createFetchRequestForApi(
    createCdsServiceT,
    options
  );

  const deleteCdsServiceT: ReplaceRequestParams<
    DeleteCdsServiceT,
    RequestParams<DeleteCdsServiceT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteCdsServiceDefaultDecoder(),
    url: ({ ["idservizio"]: idservizio }) =>
      `${basePath}/cds/services/${idservizio}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteCdsService: TypeofApiCall<DeleteCdsServiceT> = createFetchRequestForApi(
    deleteCdsServiceT,
    options
  );

  const getCdsServiceT: ReplaceRequestParams<
    GetCdsServiceT,
    RequestParams<GetCdsServiceT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCdsServiceDefaultDecoder(),
    url: ({ ["idservizio"]: idservizio }) =>
      `${basePath}/cds/services/${idservizio}`,

    query: () => withoutUndefinedValues({})
  };
  const getCdsService: TypeofApiCall<GetCdsServiceT> = createFetchRequestForApi(
    getCdsServiceT,
    options
  );

  const updateCdsServiceT: ReplaceRequestParams<
    UpdateCdsServiceT,
    RequestParams<UpdateCdsServiceT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateCdsServiceDefaultDecoder(),
    url: ({ ["idservizio"]: idservizio }) =>
      `${basePath}/cds/services/${idservizio}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateCdsService: TypeofApiCall<UpdateCdsServiceT> = createFetchRequestForApi(
    updateCdsServiceT,
    options
  );

  const getCdsSubjectsT: ReplaceRequestParams<
    GetCdsSubjectsT,
    RequestParams<GetCdsSubjectsT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCdsSubjectsDefaultDecoder(),
    url: ({}) => `${basePath}/cds/subjects`,

    query: () => withoutUndefinedValues({})
  };
  const getCdsSubjects: TypeofApiCall<GetCdsSubjectsT> = createFetchRequestForApi(
    getCdsSubjectsT,
    options
  );

  const createCdsSubjectT: ReplaceRequestParams<
    CreateCdsSubjectT,
    RequestParams<CreateCdsSubjectT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createCdsSubjectDefaultDecoder(),
    url: ({}) => `${basePath}/cds/subjects`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createCdsSubject: TypeofApiCall<CreateCdsSubjectT> = createFetchRequestForApi(
    createCdsSubjectT,
    options
  );

  const deleteCdsSubjectT: ReplaceRequestParams<
    DeleteCdsSubjectT,
    RequestParams<DeleteCdsSubjectT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteCdsSubjectDefaultDecoder(),
    url: ({ ["subjectid"]: subjectid }) =>
      `${basePath}/cds/subjects/${subjectid}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteCdsSubject: TypeofApiCall<DeleteCdsSubjectT> = createFetchRequestForApi(
    deleteCdsSubjectT,
    options
  );

  const getCdsSubjectT: ReplaceRequestParams<
    GetCdsSubjectT,
    RequestParams<GetCdsSubjectT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCdsSubjectDefaultDecoder(),
    url: ({ ["subjectid"]: subjectid }) =>
      `${basePath}/cds/subjects/${subjectid}`,

    query: () => withoutUndefinedValues({})
  };
  const getCdsSubject: TypeofApiCall<GetCdsSubjectT> = createFetchRequestForApi(
    getCdsSubjectT,
    options
  );

  const updateCdsSubjectT: ReplaceRequestParams<
    UpdateCdsSubjectT,
    RequestParams<UpdateCdsSubjectT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateCdsSubjectDefaultDecoder(),
    url: ({ ["subjectid"]: subjectid }) =>
      `${basePath}/cds/subjects/${subjectid}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateCdsSubject: TypeofApiCall<UpdateCdsSubjectT> = createFetchRequestForApi(
    updateCdsSubjectT,
    options
  );

  const getCdsSubjectServicesT: ReplaceRequestParams<
    GetCdsSubjectServicesT,
    RequestParams<GetCdsSubjectServicesT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCdsSubjectServicesDefaultDecoder(),
    url: ({ ["subjectid"]: subjectid }) =>
      `${basePath}/cds/subjects/${subjectid}/services`,

    query: () => withoutUndefinedValues({})
  };
  const getCdsSubjectServices: TypeofApiCall<GetCdsSubjectServicesT> = createFetchRequestForApi(
    getCdsSubjectServicesT,
    options
  );

  const createCdsSubjectServiceT: ReplaceRequestParams<
    CreateCdsSubjectServiceT,
    RequestParams<CreateCdsSubjectServiceT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createCdsSubjectServiceDefaultDecoder(),
    url: ({ ["subjectid"]: subjectid }) =>
      `${basePath}/cds/subjects/${subjectid}/services`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createCdsSubjectService: TypeofApiCall<CreateCdsSubjectServiceT> = createFetchRequestForApi(
    createCdsSubjectServiceT,
    options
  );

  const deleteCdsSubjectServiceT: ReplaceRequestParams<
    DeleteCdsSubjectServiceT,
    RequestParams<DeleteCdsSubjectServiceT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteCdsSubjectServiceDefaultDecoder(),
    url: ({
      ["subjectid"]: subjectid,
      ["idsoggettoservizio"]: idsoggettoservizio
    }) =>
      `${basePath}/cds/subjects/${subjectid}/services/${idsoggettoservizio}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteCdsSubjectService: TypeofApiCall<DeleteCdsSubjectServiceT> = createFetchRequestForApi(
    deleteCdsSubjectServiceT,
    options
  );

  const getCdsSubjectServiceT: ReplaceRequestParams<
    GetCdsSubjectServiceT,
    RequestParams<GetCdsSubjectServiceT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCdsSubjectServiceDefaultDecoder(),
    url: ({
      ["subjectid"]: subjectid,
      ["idsoggettoservizio"]: idsoggettoservizio
    }) =>
      `${basePath}/cds/subjects/${subjectid}/services/${idsoggettoservizio}`,

    query: () => withoutUndefinedValues({})
  };
  const getCdsSubjectService: TypeofApiCall<GetCdsSubjectServiceT> = createFetchRequestForApi(
    getCdsSubjectServiceT,
    options
  );

  const updateCdsSubjectServiceT: ReplaceRequestParams<
    UpdateCdsSubjectServiceT,
    RequestParams<UpdateCdsSubjectServiceT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateCdsSubjectServiceDefaultDecoder(),
    url: ({
      ["subjectid"]: subjectid,
      ["idsoggettoservizio"]: idsoggettoservizio
    }) =>
      `${basePath}/cds/subjects/${subjectid}/services/${idsoggettoservizio}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateCdsSubjectService: TypeofApiCall<UpdateCdsSubjectServiceT> = createFetchRequestForApi(
    updateCdsSubjectServiceT,
    options
  );

  const getChannelsT: ReplaceRequestParams<
    GetChannelsT,
    RequestParams<GetChannelsT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getChannelsDefaultDecoder(),
    url: ({}) => `${basePath}/channels`,

    query: ({
      ["limit"]: limit,
      ["page"]: page,
      ["brokercode"]: brokercode,
      ["brokerdescription"]: brokerdescription,
      ["code"]: code,
      ["ordering"]: ordering
    }) =>
      withoutUndefinedValues({
        ["limit"]: limit,
        ["page"]: page,
        ["brokercode"]: brokercode,
        ["brokerdescription"]: brokerdescription,
        ["code"]: code,
        ["ordering"]: ordering
      })
  };
  const getChannels: TypeofApiCall<GetChannelsT> = createFetchRequestForApi(
    getChannelsT,
    options
  );

  const createChannelT: ReplaceRequestParams<
    CreateChannelT,
    RequestParams<CreateChannelT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createChannelDefaultDecoder(),
    url: ({}) => `${basePath}/channels`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createChannel: TypeofApiCall<CreateChannelT> = createFetchRequestForApi(
    createChannelT,
    options
  );

  const getChannelsCSVT: ReplaceRequestParams<
    GetChannelsCSVT,
    RequestParams<GetChannelsCSVT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getChannelsCSVDefaultDecoder(),
    url: ({}) => `${basePath}/channels/csv`,

    query: () => withoutUndefinedValues({})
  };
  const getChannelsCSV: TypeofApiCall<GetChannelsCSVT> = createFetchRequestForApi(
    getChannelsCSVT,
    options
  );

  const deleteChannelT: ReplaceRequestParams<
    DeleteChannelT,
    RequestParams<DeleteChannelT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteChannelDefaultDecoder(),
    url: ({ ["channelcode"]: channelcode }) =>
      `${basePath}/channels/${channelcode}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteChannel: TypeofApiCall<DeleteChannelT> = createFetchRequestForApi(
    deleteChannelT,
    options
  );

  const getChannelT: ReplaceRequestParams<
    GetChannelT,
    RequestParams<GetChannelT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getChannelDefaultDecoder(),
    url: ({ ["channelcode"]: channelcode }) =>
      `${basePath}/channels/${channelcode}`,

    query: () => withoutUndefinedValues({})
  };
  const getChannel: TypeofApiCall<GetChannelT> = createFetchRequestForApi(
    getChannelT,
    options
  );

  const updateChannelT: ReplaceRequestParams<
    UpdateChannelT,
    RequestParams<UpdateChannelT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateChannelDefaultDecoder(),
    url: ({ ["channelcode"]: channelcode }) =>
      `${basePath}/channels/${channelcode}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateChannel: TypeofApiCall<UpdateChannelT> = createFetchRequestForApi(
    updateChannelT,
    options
  );

  const getChannelPaymentServiceProvidersT: ReplaceRequestParams<
    GetChannelPaymentServiceProvidersT,
    RequestParams<GetChannelPaymentServiceProvidersT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getChannelPaymentServiceProvidersDefaultDecoder(),
    url: ({ ["channelcode"]: channelcode }) =>
      `${basePath}/channels/${channelcode}/paymentserviceproviders`,

    query: ({
      ["limit"]: limit,
      ["page"]: page,
      ["pspCode"]: pspCode,
      ["pspName"]: pspName,
      ["pspEnabled"]: pspEnabled
    }) =>
      withoutUndefinedValues({
        ["limit"]: limit,
        ["page"]: page,
        ["pspCode"]: pspCode,
        ["pspName"]: pspName,
        ["pspEnabled"]: pspEnabled
      })
  };
  const getChannelPaymentServiceProviders: TypeofApiCall<GetChannelPaymentServiceProvidersT> = createFetchRequestForApi(
    getChannelPaymentServiceProvidersT,
    options
  );

  const getChannelPaymentServiceProvidersCSVT: ReplaceRequestParams<
    GetChannelPaymentServiceProvidersCSVT,
    RequestParams<GetChannelPaymentServiceProvidersCSVT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getChannelPaymentServiceProvidersCSVDefaultDecoder(),
    url: ({ ["channelcode"]: channelcode }) =>
      `${basePath}/channels/${channelcode}/paymentserviceproviders/csv`,

    query: () => withoutUndefinedValues({})
  };
  const getChannelPaymentServiceProvidersCSV: TypeofApiCall<GetChannelPaymentServiceProvidersCSVT> = createFetchRequestForApi(
    getChannelPaymentServiceProvidersCSVT,
    options
  );

  const getChannelPaymentTypesT: ReplaceRequestParams<
    GetChannelPaymentTypesT,
    RequestParams<GetChannelPaymentTypesT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getChannelPaymentTypesDefaultDecoder(),
    url: ({ ["channelcode"]: channelcode }) =>
      `${basePath}/channels/${channelcode}/paymenttypes`,

    query: () => withoutUndefinedValues({})
  };
  const getChannelPaymentTypes: TypeofApiCall<GetChannelPaymentTypesT> = createFetchRequestForApi(
    getChannelPaymentTypesT,
    options
  );

  const createChannelPaymentTypeT: ReplaceRequestParams<
    CreateChannelPaymentTypeT,
    RequestParams<CreateChannelPaymentTypeT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createChannelPaymentTypeDefaultDecoder(),
    url: ({ ["channelcode"]: channelcode }) =>
      `${basePath}/channels/${channelcode}/paymenttypes`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createChannelPaymentType: TypeofApiCall<CreateChannelPaymentTypeT> = createFetchRequestForApi(
    createChannelPaymentTypeT,
    options
  );

  const deleteChannelPaymentTypeT: ReplaceRequestParams<
    DeleteChannelPaymentTypeT,
    RequestParams<DeleteChannelPaymentTypeT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteChannelPaymentTypeDefaultDecoder(),
    url: ({
      ["channelcode"]: channelcode,
      ["paymenttypecode"]: paymenttypecode
    }) => `${basePath}/channels/${channelcode}/paymenttypes/${paymenttypecode}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteChannelPaymentType: TypeofApiCall<DeleteChannelPaymentTypeT> = createFetchRequestForApi(
    deleteChannelPaymentTypeT,
    options
  );

  const getFtpServersT: ReplaceRequestParams<
    GetFtpServersT,
    RequestParams<GetFtpServersT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getFtpServersDefaultDecoder(),
    url: ({}) => `${basePath}/configuration/ftpservers`,

    query: () => withoutUndefinedValues({})
  };
  const getFtpServers: TypeofApiCall<GetFtpServersT> = createFetchRequestForApi(
    getFtpServersT,
    options
  );

  const createFtpServerT: ReplaceRequestParams<
    CreateFtpServerT,
    RequestParams<CreateFtpServerT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createFtpServerDefaultDecoder(),
    url: ({}) => `${basePath}/configuration/ftpservers`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createFtpServer: TypeofApiCall<CreateFtpServerT> = createFetchRequestForApi(
    createFtpServerT,
    options
  );

  const deleteFtpServerT: ReplaceRequestParams<
    DeleteFtpServerT,
    RequestParams<DeleteFtpServerT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteFtpServerDefaultDecoder(),
    url: ({ ["host"]: host, ["port"]: port, ["service"]: service }) =>
      `${basePath}/configuration/ftpservers/host/${host}/port/${port}/service/${service}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteFtpServer: TypeofApiCall<DeleteFtpServerT> = createFetchRequestForApi(
    deleteFtpServerT,
    options
  );

  const getFtpServerT: ReplaceRequestParams<
    GetFtpServerT,
    RequestParams<GetFtpServerT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getFtpServerDefaultDecoder(),
    url: ({ ["host"]: host, ["port"]: port, ["service"]: service }) =>
      `${basePath}/configuration/ftpservers/host/${host}/port/${port}/service/${service}`,

    query: () => withoutUndefinedValues({})
  };
  const getFtpServer: TypeofApiCall<GetFtpServerT> = createFetchRequestForApi(
    getFtpServerT,
    options
  );

  const updateFtpServerT: ReplaceRequestParams<
    UpdateFtpServerT,
    RequestParams<UpdateFtpServerT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateFtpServerDefaultDecoder(),
    url: ({ ["host"]: host, ["port"]: port, ["service"]: service }) =>
      `${basePath}/configuration/ftpservers/host/${host}/port/${port}/service/${service}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateFtpServer: TypeofApiCall<UpdateFtpServerT> = createFetchRequestForApi(
    updateFtpServerT,
    options
  );

  const getConfigurationKeysT: ReplaceRequestParams<
    GetConfigurationKeysT,
    RequestParams<GetConfigurationKeysT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getConfigurationKeysDefaultDecoder(),
    url: ({}) => `${basePath}/configuration/keys`,

    query: () => withoutUndefinedValues({})
  };
  const getConfigurationKeys: TypeofApiCall<GetConfigurationKeysT> = createFetchRequestForApi(
    getConfigurationKeysT,
    options
  );

  const createConfigurationKeyT: ReplaceRequestParams<
    CreateConfigurationKeyT,
    RequestParams<CreateConfigurationKeyT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createConfigurationKeyDefaultDecoder(),
    url: ({}) => `${basePath}/configuration/keys`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createConfigurationKey: TypeofApiCall<CreateConfigurationKeyT> = createFetchRequestForApi(
    createConfigurationKeyT,
    options
  );

  const deleteConfigurationKeyT: ReplaceRequestParams<
    DeleteConfigurationKeyT,
    RequestParams<DeleteConfigurationKeyT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteConfigurationKeyDefaultDecoder(),
    url: ({ ["category"]: category, ["key"]: key }) =>
      `${basePath}/configuration/keys/category/${category}/key/${key}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteConfigurationKey: TypeofApiCall<DeleteConfigurationKeyT> = createFetchRequestForApi(
    deleteConfigurationKeyT,
    options
  );

  const getConfigurationKeyT: ReplaceRequestParams<
    GetConfigurationKeyT,
    RequestParams<GetConfigurationKeyT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getConfigurationKeyDefaultDecoder(),
    url: ({ ["category"]: category, ["key"]: key }) =>
      `${basePath}/configuration/keys/category/${category}/key/${key}`,

    query: () => withoutUndefinedValues({})
  };
  const getConfigurationKey: TypeofApiCall<GetConfigurationKeyT> = createFetchRequestForApi(
    getConfigurationKeyT,
    options
  );

  const updateConfigurationKeyT: ReplaceRequestParams<
    UpdateConfigurationKeyT,
    RequestParams<UpdateConfigurationKeyT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateConfigurationKeyDefaultDecoder(),
    url: ({ ["category"]: category, ["key"]: key }) =>
      `${basePath}/configuration/keys/category/${category}/key/${key}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateConfigurationKey: TypeofApiCall<UpdateConfigurationKeyT> = createFetchRequestForApi(
    updateConfigurationKeyT,
    options
  );

  const getPaymentTypesT: ReplaceRequestParams<
    GetPaymentTypesT,
    RequestParams<GetPaymentTypesT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getPaymentTypesDefaultDecoder(),
    url: ({}) => `${basePath}/configuration/paymenttypes`,

    query: () => withoutUndefinedValues({})
  };
  const getPaymentTypes: TypeofApiCall<GetPaymentTypesT> = createFetchRequestForApi(
    getPaymentTypesT,
    options
  );

  const createPaymentTypeT: ReplaceRequestParams<
    CreatePaymentTypeT,
    RequestParams<CreatePaymentTypeT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createPaymentTypeDefaultDecoder(),
    url: ({}) => `${basePath}/configuration/paymenttypes`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createPaymentType: TypeofApiCall<CreatePaymentTypeT> = createFetchRequestForApi(
    createPaymentTypeT,
    options
  );

  const uploadHistoryT: ReplaceRequestParams<
    UploadHistoryT,
    RequestParams<UploadHistoryT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: uploadHistoryDefaultDecoder(),
    url: ({}) => `${basePath}/configuration/paymenttypes/history`,

    query: () => withoutUndefinedValues({})
  };
  const uploadHistory: TypeofApiCall<UploadHistoryT> = createFetchRequestForApi(
    uploadHistoryT,
    options
  );

  const deletePaymentTypeT: ReplaceRequestParams<
    DeletePaymentTypeT,
    RequestParams<DeletePaymentTypeT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deletePaymentTypeDefaultDecoder(),
    url: ({ ["paymentTypeCode"]: paymentTypeCode }) =>
      `${basePath}/configuration/paymenttypes/${paymentTypeCode}`,

    query: () => withoutUndefinedValues({})
  };
  const deletePaymentType: TypeofApiCall<DeletePaymentTypeT> = createFetchRequestForApi(
    deletePaymentTypeT,
    options
  );

  const getPaymentTypeT: ReplaceRequestParams<
    GetPaymentTypeT,
    RequestParams<GetPaymentTypeT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getPaymentTypeDefaultDecoder(),
    url: ({ ["paymentTypeCode"]: paymentTypeCode }) =>
      `${basePath}/configuration/paymenttypes/${paymentTypeCode}`,

    query: () => withoutUndefinedValues({})
  };
  const getPaymentType: TypeofApiCall<GetPaymentTypeT> = createFetchRequestForApi(
    getPaymentTypeT,
    options
  );

  const updatePaymentTypeT: ReplaceRequestParams<
    UpdatePaymentTypeT,
    RequestParams<UpdatePaymentTypeT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updatePaymentTypeDefaultDecoder(),
    url: ({ ["paymentTypeCode"]: paymentTypeCode }) =>
      `${basePath}/configuration/paymenttypes/${paymentTypeCode}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updatePaymentType: TypeofApiCall<UpdatePaymentTypeT> = createFetchRequestForApi(
    updatePaymentTypeT,
    options
  );

  const getPddsT: ReplaceRequestParams<GetPddsT, RequestParams<GetPddsT>> = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getPddsDefaultDecoder(),
    url: ({}) => `${basePath}/configuration/pdds`,

    query: () => withoutUndefinedValues({})
  };
  const getPdds: TypeofApiCall<GetPddsT> = createFetchRequestForApi(
    getPddsT,
    options
  );

  const createPddT: ReplaceRequestParams<
    CreatePddT,
    RequestParams<CreatePddT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createPddDefaultDecoder(),
    url: ({}) => `${basePath}/configuration/pdds`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createPdd: TypeofApiCall<CreatePddT> = createFetchRequestForApi(
    createPddT,
    options
  );

  const deletePddT: ReplaceRequestParams<
    DeletePddT,
    RequestParams<DeletePddT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deletePddDefaultDecoder(),
    url: ({ ["id_pdd"]: idPdd }) => `${basePath}/configuration/pdds/${idPdd}`,

    query: () => withoutUndefinedValues({})
  };
  const deletePdd: TypeofApiCall<DeletePddT> = createFetchRequestForApi(
    deletePddT,
    options
  );

  const getPddT: ReplaceRequestParams<GetPddT, RequestParams<GetPddT>> = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getPddDefaultDecoder(),
    url: ({ ["id_pdd"]: idPdd }) => `${basePath}/configuration/pdds/${idPdd}`,

    query: () => withoutUndefinedValues({})
  };
  const getPdd: TypeofApiCall<GetPddT> = createFetchRequestForApi(
    getPddT,
    options
  );

  const updatePddT: ReplaceRequestParams<
    UpdatePddT,
    RequestParams<UpdatePddT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updatePddDefaultDecoder(),
    url: ({ ["id_pdd"]: idPdd }) => `${basePath}/configuration/pdds/${idPdd}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updatePdd: TypeofApiCall<UpdatePddT> = createFetchRequestForApi(
    updatePddT,
    options
  );

  const getWfespPluginsT: ReplaceRequestParams<
    GetWfespPluginsT,
    RequestParams<GetWfespPluginsT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getWfespPluginsDefaultDecoder(),
    url: ({}) => `${basePath}/configuration/wfespplugins`,

    query: () => withoutUndefinedValues({})
  };
  const getWfespPlugins: TypeofApiCall<GetWfespPluginsT> = createFetchRequestForApi(
    getWfespPluginsT,
    options
  );

  const createWfespPluginT: ReplaceRequestParams<
    CreateWfespPluginT,
    RequestParams<CreateWfespPluginT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createWfespPluginDefaultDecoder(),
    url: ({}) => `${basePath}/configuration/wfespplugins`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createWfespPlugin: TypeofApiCall<CreateWfespPluginT> = createFetchRequestForApi(
    createWfespPluginT,
    options
  );

  const deleteWfespPluginT: ReplaceRequestParams<
    DeleteWfespPluginT,
    RequestParams<DeleteWfespPluginT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteWfespPluginDefaultDecoder(),
    url: ({ ["idServPlugin"]: idServPlugin }) =>
      `${basePath}/configuration/wfespplugins/${idServPlugin}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteWfespPlugin: TypeofApiCall<DeleteWfespPluginT> = createFetchRequestForApi(
    deleteWfespPluginT,
    options
  );

  const getWfespPluginT: ReplaceRequestParams<
    GetWfespPluginT,
    RequestParams<GetWfespPluginT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getWfespPluginDefaultDecoder(),
    url: ({ ["idServPlugin"]: idServPlugin }) =>
      `${basePath}/configuration/wfespplugins/${idServPlugin}`,

    query: () => withoutUndefinedValues({})
  };
  const getWfespPlugin: TypeofApiCall<GetWfespPluginT> = createFetchRequestForApi(
    getWfespPluginT,
    options
  );

  const updateWfespPluginT: ReplaceRequestParams<
    UpdateWfespPluginT,
    RequestParams<UpdateWfespPluginT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateWfespPluginDefaultDecoder(),
    url: ({ ["idServPlugin"]: idServPlugin }) =>
      `${basePath}/configuration/wfespplugins/${idServPlugin}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateWfespPlugin: TypeofApiCall<UpdateWfespPluginT> = createFetchRequestForApi(
    updateWfespPluginT,
    options
  );

  const getCounterpartTablesT: ReplaceRequestParams<
    GetCounterpartTablesT,
    RequestParams<GetCounterpartTablesT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCounterpartTablesDefaultDecoder(),
    url: ({}) => `${basePath}/counterparttables`,

    query: ({
      ["limit"]: limit,
      ["page"]: page,
      ["idcounterparttable"]: idcounterparttable,
      ["creditorinstitutioncode"]: creditorinstitutioncode
    }) =>
      withoutUndefinedValues({
        ["limit"]: limit,
        ["page"]: page,
        ["idcounterparttable"]: idcounterparttable,
        ["creditorinstitutioncode"]: creditorinstitutioncode
      })
  };
  const getCounterpartTables: TypeofApiCall<GetCounterpartTablesT> = createFetchRequestForApi(
    getCounterpartTablesT,
    options
  );

  const createCounterpartTableT: ReplaceRequestParams<
    CreateCounterpartTableT,
    RequestParams<CreateCounterpartTableT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "multipart/form-data"
    }),
    response_decoder: createCounterpartTableDefaultDecoder(),
    url: ({}) => `${basePath}/counterparttables`,

    body: ({ ["file"]: file }) => file.uri,

    query: () => withoutUndefinedValues({})
  };
  const createCounterpartTable: TypeofApiCall<CreateCounterpartTableT> = createFetchRequestForApi(
    createCounterpartTableT,
    options
  );

  const deleteCounterpartTableT: ReplaceRequestParams<
    DeleteCounterpartTableT,
    RequestParams<DeleteCounterpartTableT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteCounterpartTableDefaultDecoder(),
    url: ({ ["idcounterparttable"]: idcounterparttable }) =>
      `${basePath}/counterparttables/${idcounterparttable}`,

    query: ({ ["creditorinstitutioncode"]: creditorinstitutioncode }) =>
      withoutUndefinedValues({
        ["creditorinstitutioncode"]: creditorinstitutioncode
      })
  };
  const deleteCounterpartTable: TypeofApiCall<DeleteCounterpartTableT> = createFetchRequestForApi(
    deleteCounterpartTableT,
    options
  );

  const getCounterpartTableT: ReplaceRequestParams<
    GetCounterpartTableT,
    RequestParams<GetCounterpartTableT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCounterpartTableDefaultDecoder(),
    url: ({ ["idcounterparttable"]: idcounterparttable }) =>
      `${basePath}/counterparttables/${idcounterparttable}`,

    query: ({ ["creditorinstitutioncode"]: creditorinstitutioncode }) =>
      withoutUndefinedValues({
        ["creditorinstitutioncode"]: creditorinstitutioncode
      })
  };
  const getCounterpartTable: TypeofApiCall<GetCounterpartTableT> = createFetchRequestForApi(
    getCounterpartTableT,
    options
  );

  const getCreditorInstitutionsT: ReplaceRequestParams<
    GetCreditorInstitutionsT,
    RequestParams<GetCreditorInstitutionsT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCreditorInstitutionsDefaultDecoder(),
    url: ({}) => `${basePath}/creditorinstitutions`,

    query: ({
      ["code"]: code,
      ["name"]: name,
      ["enabled"]: enabled,
      ["orderby"]: orderby,
      ["ordering"]: ordering,
      ["limit"]: limit,
      ["page"]: page,
      ["hasCBILL"]: hasCBILL,
      ["hasValidIban"]: hasValidIban
    }) =>
      withoutUndefinedValues({
        ["code"]: code,
        ["name"]: name,
        ["enabled"]: enabled,
        ["orderby"]: orderby,
        ["ordering"]: ordering,
        ["limit"]: limit,
        ["page"]: page,
        ["hasCBILL"]: hasCBILL,
        ["hasValidIban"]: hasValidIban
      })
  };
  const getCreditorInstitutions: TypeofApiCall<GetCreditorInstitutionsT> = createFetchRequestForApi(
    getCreditorInstitutionsT,
    options
  );

  const createCreditorInstitutionT: ReplaceRequestParams<
    CreateCreditorInstitutionT,
    RequestParams<CreateCreditorInstitutionT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createCreditorInstitutionDefaultDecoder(),
    url: ({}) => `${basePath}/creditorinstitutions`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createCreditorInstitution: TypeofApiCall<CreateCreditorInstitutionT> = createFetchRequestForApi(
    createCreditorInstitutionT,
    options
  );

  const massiveUploadCbillCsvT: ReplaceRequestParams<
    MassiveUploadCbillCsvT,
    RequestParams<MassiveUploadCbillCsvT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "multipart/form-data"
    }),
    response_decoder: massiveUploadCbillCsvDefaultDecoder(),
    url: ({}) => `${basePath}/creditorinstitutions/cbill`,

    body: ({ ["file"]: file }) => file.uri,

    query: ({ ["incremental"]: incremental }) =>
      withoutUndefinedValues({ ["incremental"]: incremental })
  };
  const massiveUploadCbillCsv: TypeofApiCall<MassiveUploadCbillCsvT> = createFetchRequestForApi(
    massiveUploadCbillCsvT,
    options
  );

  const massiveCreateIbansT: ReplaceRequestParams<
    MassiveCreateIbansT,
    RequestParams<MassiveCreateIbansT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "multipart/form-data"
    }),
    response_decoder: massiveCreateIbansDefaultDecoder(),
    url: ({}) => `${basePath}/creditorinstitutions/ibans`,

    body: ({ ["file"]: file }) => file.uri,

    query: () => withoutUndefinedValues({})
  };
  const massiveCreateIbans: TypeofApiCall<MassiveCreateIbansT> = createFetchRequestForApi(
    massiveCreateIbansT,
    options
  );

  const massiveCreateIbansCsvT: ReplaceRequestParams<
    MassiveCreateIbansCsvT,
    RequestParams<MassiveCreateIbansCsvT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "multipart/form-data"
    }),
    response_decoder: massiveCreateIbansCsvDefaultDecoder(),
    url: ({}) => `${basePath}/creditorinstitutions/ibans/csv`,

    body: ({ ["file"]: file }) => file.uri,

    query: () => withoutUndefinedValues({})
  };
  const massiveCreateIbansCsv: TypeofApiCall<MassiveCreateIbansCsvT> = createFetchRequestForApi(
    massiveCreateIbansCsvT,
    options
  );

  const upsertIbanLabelT: ReplaceRequestParams<
    UpsertIbanLabelT,
    RequestParams<UpsertIbanLabelT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: upsertIbanLabelDefaultDecoder(),
    url: ({}) => `${basePath}/creditorinstitutions/ibans/labels`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const upsertIbanLabel: TypeofApiCall<UpsertIbanLabelT> = createFetchRequestForApi(
    upsertIbanLabelT,
    options
  );

  const getCreditorInstitutionsViewT: ReplaceRequestParams<
    GetCreditorInstitutionsViewT,
    RequestParams<GetCreditorInstitutionsViewT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCreditorInstitutionsViewDefaultDecoder(),
    url: ({}) => `${basePath}/creditorinstitutions/view`,

    query: ({
      ["limit"]: limit,
      ["page"]: page,
      ["creditorInstitutionCode"]: creditorInstitutionCode,
      ["paBrokerCode"]: paBrokerCode,
      ["stationCode"]: stationCode,
      ["enabled"]: enabled,
      ["auxDigit"]: auxDigit,
      ["applicationCode"]: applicationCode,
      ["segregationCode"]: segregationCode,
      ["mod4"]: mod4
    }) =>
      withoutUndefinedValues({
        ["limit"]: limit,
        ["page"]: page,
        ["creditorInstitutionCode"]: creditorInstitutionCode,
        ["paBrokerCode"]: paBrokerCode,
        ["stationCode"]: stationCode,
        ["enabled"]: enabled,
        ["auxDigit"]: auxDigit,
        ["applicationCode"]: applicationCode,
        ["segregationCode"]: segregationCode,
        ["mod4"]: mod4
      })
  };
  const getCreditorInstitutionsView: TypeofApiCall<GetCreditorInstitutionsViewT> = createFetchRequestForApi(
    getCreditorInstitutionsViewT,
    options
  );

  const deleteCreditorInstitutionT: ReplaceRequestParams<
    DeleteCreditorInstitutionT,
    RequestParams<DeleteCreditorInstitutionT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteCreditorInstitutionDefaultDecoder(),
    url: ({ ["creditorinstitutioncode"]: creditorinstitutioncode }) =>
      `${basePath}/creditorinstitutions/${creditorinstitutioncode}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteCreditorInstitution: TypeofApiCall<DeleteCreditorInstitutionT> = createFetchRequestForApi(
    deleteCreditorInstitutionT,
    options
  );

  const getCreditorInstitutionT: ReplaceRequestParams<
    GetCreditorInstitutionT,
    RequestParams<GetCreditorInstitutionT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCreditorInstitutionDefaultDecoder(),
    url: ({ ["creditorinstitutioncode"]: creditorinstitutioncode }) =>
      `${basePath}/creditorinstitutions/${creditorinstitutioncode}`,

    query: () => withoutUndefinedValues({})
  };
  const getCreditorInstitution: TypeofApiCall<GetCreditorInstitutionT> = createFetchRequestForApi(
    getCreditorInstitutionT,
    options
  );

  const updateCreditorInstitutionT: ReplaceRequestParams<
    UpdateCreditorInstitutionT,
    RequestParams<UpdateCreditorInstitutionT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateCreditorInstitutionDefaultDecoder(),
    url: ({ ["creditorinstitutioncode"]: creditorinstitutioncode }) =>
      `${basePath}/creditorinstitutions/${creditorinstitutioncode}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateCreditorInstitution: TypeofApiCall<UpdateCreditorInstitutionT> = createFetchRequestForApi(
    updateCreditorInstitutionT,
    options
  );

  const getCreditorInstitutionEncodingsT: ReplaceRequestParams<
    GetCreditorInstitutionEncodingsT,
    RequestParams<GetCreditorInstitutionEncodingsT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCreditorInstitutionEncodingsDefaultDecoder(),
    url: ({ ["creditorinstitutioncode"]: creditorinstitutioncode }) =>
      `${basePath}/creditorinstitutions/${creditorinstitutioncode}/encodings`,

    query: () => withoutUndefinedValues({})
  };
  const getCreditorInstitutionEncodings: TypeofApiCall<GetCreditorInstitutionEncodingsT> = createFetchRequestForApi(
    getCreditorInstitutionEncodingsT,
    options
  );

  const createCreditorInstitutionEncodingT: ReplaceRequestParams<
    CreateCreditorInstitutionEncodingT,
    RequestParams<CreateCreditorInstitutionEncodingT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createCreditorInstitutionEncodingDefaultDecoder(),
    url: ({ ["creditorinstitutioncode"]: creditorinstitutioncode }) =>
      `${basePath}/creditorinstitutions/${creditorinstitutioncode}/encodings`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createCreditorInstitutionEncoding: TypeofApiCall<CreateCreditorInstitutionEncodingT> = createFetchRequestForApi(
    createCreditorInstitutionEncodingT,
    options
  );

  const deleteCreditorInstitutionEncodingT: ReplaceRequestParams<
    DeleteCreditorInstitutionEncodingT,
    RequestParams<DeleteCreditorInstitutionEncodingT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteCreditorInstitutionEncodingDefaultDecoder(),
    url: ({
      ["creditorinstitutioncode"]: creditorinstitutioncode,
      ["encodingcode"]: encodingcode
    }) =>
      `${basePath}/creditorinstitutions/${creditorinstitutioncode}/encodings/${encodingcode}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteCreditorInstitutionEncoding: TypeofApiCall<DeleteCreditorInstitutionEncodingT> = createFetchRequestForApi(
    deleteCreditorInstitutionEncodingT,
    options
  );

  const getCreditorInstitutionsIbansT: ReplaceRequestParams<
    GetCreditorInstitutionsIbansT,
    RequestParams<GetCreditorInstitutionsIbansT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCreditorInstitutionsIbansDefaultDecoder(),
    url: ({ ["creditorinstitutioncode"]: creditorinstitutioncode }) =>
      `${basePath}/creditorinstitutions/${creditorinstitutioncode}/ibans`,

    query: () => withoutUndefinedValues({})
  };
  const getCreditorInstitutionsIbans: TypeofApiCall<GetCreditorInstitutionsIbansT> = createFetchRequestForApi(
    getCreditorInstitutionsIbansT,
    options
  );

  const createCreditorInstitutionsIbansT: ReplaceRequestParams<
    CreateCreditorInstitutionsIbansT,
    RequestParams<CreateCreditorInstitutionsIbansT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createCreditorInstitutionsIbansDefaultDecoder(),
    url: ({ ["creditorinstitutioncode"]: creditorinstitutioncode }) =>
      `${basePath}/creditorinstitutions/${creditorinstitutioncode}/ibans`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createCreditorInstitutionsIbans: TypeofApiCall<CreateCreditorInstitutionsIbansT> = createFetchRequestForApi(
    createCreditorInstitutionsIbansT,
    options
  );

  const getIbansT: ReplaceRequestParams<GetIbansT, RequestParams<GetIbansT>> = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getIbansDefaultDecoder(),
    url: ({ ["creditorinstitutioncode"]: creditorinstitutioncode }) =>
      `${basePath}/creditorinstitutions/${creditorinstitutioncode}/ibans/list`,

    query: ({
      ["limit"]: limit,
      ["page"]: page,
      ["label"]: label,
      ["iban"]: iban
    }) =>
      withoutUndefinedValues({
        ["limit"]: limit,
        ["page"]: page,
        ["label"]: label,
        ["iban"]: iban
      })
  };
  const getIbans: TypeofApiCall<GetIbansT> = createFetchRequestForApi(
    getIbansT,
    options
  );

  const updateCreditorInstitutionsIbansT: ReplaceRequestParams<
    UpdateCreditorInstitutionsIbansT,
    RequestParams<UpdateCreditorInstitutionsIbansT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateCreditorInstitutionsIbansDefaultDecoder(),
    url: ({
      ["creditorinstitutioncode"]: creditorinstitutioncode,
      ["ibanId"]: ibanId
    }) =>
      `${basePath}/creditorinstitutions/${creditorinstitutioncode}/ibans/${ibanId}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateCreditorInstitutionsIbans: TypeofApiCall<UpdateCreditorInstitutionsIbansT> = createFetchRequestForApi(
    updateCreditorInstitutionsIbansT,
    options
  );

  const deleteCreditorInstitutionsIbanT: ReplaceRequestParams<
    DeleteCreditorInstitutionsIbanT,
    RequestParams<DeleteCreditorInstitutionsIbanT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteCreditorInstitutionsIbanDefaultDecoder(),
    url: ({
      ["creditorinstitutioncode"]: creditorinstitutioncode,
      ["ibanValue"]: ibanValue
    }) =>
      `${basePath}/creditorinstitutions/${creditorinstitutioncode}/ibans/${ibanValue}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteCreditorInstitutionsIban: TypeofApiCall<DeleteCreditorInstitutionsIbanT> = createFetchRequestForApi(
    deleteCreditorInstitutionsIbanT,
    options
  );

  const getCreditorInstitutionStationsT: ReplaceRequestParams<
    GetCreditorInstitutionStationsT,
    RequestParams<GetCreditorInstitutionStationsT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCreditorInstitutionStationsDefaultDecoder(),
    url: ({ ["creditorinstitutioncode"]: creditorinstitutioncode }) =>
      `${basePath}/creditorinstitutions/${creditorinstitutioncode}/stations`,

    query: () => withoutUndefinedValues({})
  };
  const getCreditorInstitutionStations: TypeofApiCall<GetCreditorInstitutionStationsT> = createFetchRequestForApi(
    getCreditorInstitutionStationsT,
    options
  );

  const createCreditorInstitutionStationT: ReplaceRequestParams<
    CreateCreditorInstitutionStationT,
    RequestParams<CreateCreditorInstitutionStationT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createCreditorInstitutionStationDefaultDecoder(),
    url: ({ ["creditorinstitutioncode"]: creditorinstitutioncode }) =>
      `${basePath}/creditorinstitutions/${creditorinstitutioncode}/stations`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createCreditorInstitutionStation: TypeofApiCall<CreateCreditorInstitutionStationT> = createFetchRequestForApi(
    createCreditorInstitutionStationT,
    options
  );

  const deleteCreditorInstitutionStationT: ReplaceRequestParams<
    DeleteCreditorInstitutionStationT,
    RequestParams<DeleteCreditorInstitutionStationT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteCreditorInstitutionStationDefaultDecoder(),
    url: ({
      ["creditorinstitutioncode"]: creditorinstitutioncode,
      ["stationcode"]: stationcode
    }) =>
      `${basePath}/creditorinstitutions/${creditorinstitutioncode}/stations/${stationcode}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteCreditorInstitutionStation: TypeofApiCall<DeleteCreditorInstitutionStationT> = createFetchRequestForApi(
    deleteCreditorInstitutionStationT,
    options
  );

  const updateCreditorInstitutionStationT: ReplaceRequestParams<
    UpdateCreditorInstitutionStationT,
    RequestParams<UpdateCreditorInstitutionStationT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateCreditorInstitutionStationDefaultDecoder(),
    url: ({
      ["creditorinstitutioncode"]: creditorinstitutioncode,
      ["stationcode"]: stationcode
    }) =>
      `${basePath}/creditorinstitutions/${creditorinstitutioncode}/stations/${stationcode}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateCreditorInstitutionStation: TypeofApiCall<UpdateCreditorInstitutionStationT> = createFetchRequestForApi(
    updateCreditorInstitutionStationT,
    options
  );

  const getCreditorInstitutionByPostalEncodingT: ReplaceRequestParams<
    GetCreditorInstitutionByPostalEncodingT,
    RequestParams<GetCreditorInstitutionByPostalEncodingT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCreditorInstitutionByPostalEncodingDefaultDecoder(),
    url: ({ ["encodingcode"]: encodingcode }) =>
      `${basePath}/encodings/${encodingcode}`,

    query: () => withoutUndefinedValues({})
  };
  const getCreditorInstitutionByPostalEncoding: TypeofApiCall<GetCreditorInstitutionByPostalEncodingT> = createFetchRequestForApi(
    getCreditorInstitutionByPostalEncodingT,
    options
  );

  const getCreditorInstitutionsByIbanT: ReplaceRequestParams<
    GetCreditorInstitutionsByIbanT,
    RequestParams<GetCreditorInstitutionsByIbanT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getCreditorInstitutionsByIbanDefaultDecoder(),
    url: ({ ["iban"]: iban }) => `${basePath}/ibans/${iban}`,

    query: () => withoutUndefinedValues({})
  };
  const getCreditorInstitutionsByIban: TypeofApiCall<GetCreditorInstitutionsByIbanT> = createFetchRequestForApi(
    getCreditorInstitutionsByIbanT,
    options
  );

  const getIcasT: ReplaceRequestParams<GetIcasT, RequestParams<GetIcasT>> = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getIcasDefaultDecoder(),
    url: ({}) => `${basePath}/icas`,

    query: ({
      ["limit"]: limit,
      ["page"]: page,
      ["idica"]: idica,
      ["creditorinstitutioncode"]: creditorinstitutioncode
    }) =>
      withoutUndefinedValues({
        ["limit"]: limit,
        ["page"]: page,
        ["idica"]: idica,
        ["creditorinstitutioncode"]: creditorinstitutioncode
      })
  };
  const getIcas: TypeofApiCall<GetIcasT> = createFetchRequestForApi(
    getIcasT,
    options
  );

  const createIcaT: ReplaceRequestParams<
    CreateIcaT,
    RequestParams<CreateIcaT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "multipart/form-data"
    }),
    response_decoder: createIcaDefaultDecoder(),
    url: ({}) => `${basePath}/icas`,

    body: ({ ["file"]: file }) => file.uri,

    query: ({ ["force"]: force }) =>
      withoutUndefinedValues({ ["force"]: force })
  };
  const createIca: TypeofApiCall<CreateIcaT> = createFetchRequestForApi(
    createIcaT,
    options
  );

  const verifyIcaT: ReplaceRequestParams<
    VerifyIcaT,
    RequestParams<VerifyIcaT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "multipart/form-data"
    }),
    response_decoder: verifyIcaDefaultDecoder(),
    url: ({}) => `${basePath}/icas/check`,

    body: ({ ["file"]: file }) => file.uri,

    query: () => withoutUndefinedValues({})
  };
  const verifyIca: TypeofApiCall<VerifyIcaT> = createFetchRequestForApi(
    verifyIcaT,
    options
  );

  const massiveVerifyIcasT: ReplaceRequestParams<
    MassiveVerifyIcasT,
    RequestParams<MassiveVerifyIcasT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "multipart/form-data"
    }),
    response_decoder: massiveVerifyIcasDefaultDecoder(),
    url: ({}) => `${basePath}/icas/check/massive`,

    body: ({ ["file"]: file }) => file.uri,

    query: () => withoutUndefinedValues({})
  };
  const massiveVerifyIcas: TypeofApiCall<MassiveVerifyIcasT> = createFetchRequestForApi(
    massiveVerifyIcasT,
    options
  );

  const massiveCreateIcasT: ReplaceRequestParams<
    MassiveCreateIcasT,
    RequestParams<MassiveCreateIcasT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "multipart/form-data"
    }),
    response_decoder: massiveCreateIcasDefaultDecoder(),
    url: ({}) => `${basePath}/icas/massive`,

    body: ({ ["file"]: file }) => file.uri,

    query: () => withoutUndefinedValues({})
  };
  const massiveCreateIcas: TypeofApiCall<MassiveCreateIcasT> = createFetchRequestForApi(
    massiveCreateIcasT,
    options
  );

  const checkXSDT: ReplaceRequestParams<CheckXSDT, RequestParams<CheckXSDT>> = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "multipart/form-data"
    }),
    response_decoder: checkXSDDefaultDecoder(),
    url: ({}) => `${basePath}/icas/xsd`,

    body: ({ ["file"]: file }) => file.uri,

    query: () => withoutUndefinedValues({})
  };
  const checkXSD: TypeofApiCall<CheckXSDT> = createFetchRequestForApi(
    checkXSDT,
    options
  );

  const deleteIcaT: ReplaceRequestParams<
    DeleteIcaT,
    RequestParams<DeleteIcaT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteIcaDefaultDecoder(),
    url: ({ ["idica"]: idica }) => `${basePath}/icas/${idica}`,

    query: ({ ["creditorinstitutioncode"]: creditorinstitutioncode }) =>
      withoutUndefinedValues({
        ["creditorinstitutioncode"]: creditorinstitutioncode
      })
  };
  const deleteIca: TypeofApiCall<DeleteIcaT> = createFetchRequestForApi(
    deleteIcaT,
    options
  );

  const getIcaT: ReplaceRequestParams<GetIcaT, RequestParams<GetIcaT>> = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getIcaDefaultDecoder(),
    url: ({ ["idica"]: idica }) => `${basePath}/icas/${idica}`,

    query: ({ ["creditorinstitutioncode"]: creditorinstitutioncode }) =>
      withoutUndefinedValues({
        ["creditorinstitutioncode"]: creditorinstitutioncode
      })
  };
  const getIca: TypeofApiCall<GetIcaT> = createFetchRequestForApi(
    getIcaT,
    options
  );

  const healthCheckT: ReplaceRequestParams<
    HealthCheckT,
    RequestParams<HealthCheckT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: healthCheckDefaultDecoder(),
    url: ({}) => `${basePath}/info`,

    query: () => withoutUndefinedValues({})
  };
  const healthCheck: TypeofApiCall<HealthCheckT> = createFetchRequestForApi(
    healthCheckT,
    options
  );

  const getPaymentServiceProvidersT: ReplaceRequestParams<
    GetPaymentServiceProvidersT,
    RequestParams<GetPaymentServiceProvidersT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getPaymentServiceProvidersDefaultDecoder(),
    url: ({}) => `${basePath}/paymentserviceproviders`,

    query: ({
      ["limit"]: limit,
      ["page"]: page,
      ["code"]: code,
      ["name"]: name,
      ["taxCode"]: taxCode,
      ["orderby"]: orderby,
      ["ordering"]: ordering
    }) =>
      withoutUndefinedValues({
        ["limit"]: limit,
        ["page"]: page,
        ["code"]: code,
        ["name"]: name,
        ["taxCode"]: taxCode,
        ["orderby"]: orderby,
        ["ordering"]: ordering
      })
  };
  const getPaymentServiceProviders: TypeofApiCall<GetPaymentServiceProvidersT> = createFetchRequestForApi(
    getPaymentServiceProvidersT,
    options
  );

  const createPaymentServiceProviderT: ReplaceRequestParams<
    CreatePaymentServiceProviderT,
    RequestParams<CreatePaymentServiceProviderT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createPaymentServiceProviderDefaultDecoder(),
    url: ({}) => `${basePath}/paymentserviceproviders`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createPaymentServiceProvider: TypeofApiCall<CreatePaymentServiceProviderT> = createFetchRequestForApi(
    createPaymentServiceProviderT,
    options
  );

  const getPaymentServiceProvidersViewT: ReplaceRequestParams<
    GetPaymentServiceProvidersViewT,
    RequestParams<GetPaymentServiceProvidersViewT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getPaymentServiceProvidersViewDefaultDecoder(),
    url: ({}) => `${basePath}/paymentserviceproviders/view`,

    query: ({
      ["limit"]: limit,
      ["page"]: page,
      ["pspCode"]: pspCode,
      ["pspBrokerCode"]: pspBrokerCode,
      ["channelCode"]: channelCode,
      ["paymentType"]: paymentType,
      ["paymentModel"]: paymentModel
    }) =>
      withoutUndefinedValues({
        ["limit"]: limit,
        ["page"]: page,
        ["pspCode"]: pspCode,
        ["pspBrokerCode"]: pspBrokerCode,
        ["channelCode"]: channelCode,
        ["paymentType"]: paymentType,
        ["paymentModel"]: paymentModel
      })
  };
  const getPaymentServiceProvidersView: TypeofApiCall<GetPaymentServiceProvidersViewT> = createFetchRequestForApi(
    getPaymentServiceProvidersViewT,
    options
  );

  const deletePaymentServiceProviderT: ReplaceRequestParams<
    DeletePaymentServiceProviderT,
    RequestParams<DeletePaymentServiceProviderT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deletePaymentServiceProviderDefaultDecoder(),
    url: ({ ["pspcode"]: pspcode }) =>
      `${basePath}/paymentserviceproviders/${pspcode}`,

    query: () => withoutUndefinedValues({})
  };
  const deletePaymentServiceProvider: TypeofApiCall<DeletePaymentServiceProviderT> = createFetchRequestForApi(
    deletePaymentServiceProviderT,
    options
  );

  const getPaymentServiceProviderT: ReplaceRequestParams<
    GetPaymentServiceProviderT,
    RequestParams<GetPaymentServiceProviderT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getPaymentServiceProviderDefaultDecoder(),
    url: ({ ["pspcode"]: pspcode }) =>
      `${basePath}/paymentserviceproviders/${pspcode}`,

    query: () => withoutUndefinedValues({})
  };
  const getPaymentServiceProvider: TypeofApiCall<GetPaymentServiceProviderT> = createFetchRequestForApi(
    getPaymentServiceProviderT,
    options
  );

  const updatePaymentServiceProviderT: ReplaceRequestParams<
    UpdatePaymentServiceProviderT,
    RequestParams<UpdatePaymentServiceProviderT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updatePaymentServiceProviderDefaultDecoder(),
    url: ({ ["pspcode"]: pspcode }) =>
      `${basePath}/paymentserviceproviders/${pspcode}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updatePaymentServiceProvider: TypeofApiCall<UpdatePaymentServiceProviderT> = createFetchRequestForApi(
    updatePaymentServiceProviderT,
    options
  );

  const getPaymentServiceProvidersChannelsT: ReplaceRequestParams<
    GetPaymentServiceProvidersChannelsT,
    RequestParams<GetPaymentServiceProvidersChannelsT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getPaymentServiceProvidersChannelsDefaultDecoder(),
    url: ({ ["pspcode"]: pspcode }) =>
      `${basePath}/paymentserviceproviders/${pspcode}/channels`,

    query: () => withoutUndefinedValues({})
  };
  const getPaymentServiceProvidersChannels: TypeofApiCall<GetPaymentServiceProvidersChannelsT> = createFetchRequestForApi(
    getPaymentServiceProvidersChannelsT,
    options
  );

  const createPaymentServiceProvidersChannelsT: ReplaceRequestParams<
    CreatePaymentServiceProvidersChannelsT,
    RequestParams<CreatePaymentServiceProvidersChannelsT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createPaymentServiceProvidersChannelsDefaultDecoder(),
    url: ({ ["pspcode"]: pspcode }) =>
      `${basePath}/paymentserviceproviders/${pspcode}/channels`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createPaymentServiceProvidersChannels: TypeofApiCall<CreatePaymentServiceProvidersChannelsT> = createFetchRequestForApi(
    createPaymentServiceProvidersChannelsT,
    options
  );

  const deletePaymentServiceProvidersChannelsT: ReplaceRequestParams<
    DeletePaymentServiceProvidersChannelsT,
    RequestParams<DeletePaymentServiceProvidersChannelsT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deletePaymentServiceProvidersChannelsDefaultDecoder(),
    url: ({ ["pspcode"]: pspcode, ["channelcode"]: channelcode }) =>
      `${basePath}/paymentserviceproviders/${pspcode}/channels/${channelcode}`,

    query: () => withoutUndefinedValues({})
  };
  const deletePaymentServiceProvidersChannels: TypeofApiCall<DeletePaymentServiceProvidersChannelsT> = createFetchRequestForApi(
    deletePaymentServiceProvidersChannelsT,
    options
  );

  const updatePaymentServiceProvidersChannelsT: ReplaceRequestParams<
    UpdatePaymentServiceProvidersChannelsT,
    RequestParams<UpdatePaymentServiceProvidersChannelsT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updatePaymentServiceProvidersChannelsDefaultDecoder(),
    url: ({ ["pspcode"]: pspcode, ["channelcode"]: channelcode }) =>
      `${basePath}/paymentserviceproviders/${pspcode}/channels/${channelcode}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updatePaymentServiceProvidersChannels: TypeofApiCall<UpdatePaymentServiceProvidersChannelsT> = createFetchRequestForApi(
    updatePaymentServiceProvidersChannelsT,
    options
  );

  const getRefreshGlobalConfigT: ReplaceRequestParams<
    GetRefreshGlobalConfigT,
    RequestParams<GetRefreshGlobalConfigT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getRefreshGlobalConfigDefaultDecoder(),
    url: ({}) => `${basePath}/refresh/config`,

    query: () => withoutUndefinedValues({})
  };
  const getRefreshGlobalConfig: TypeofApiCall<GetRefreshGlobalConfigT> = createFetchRequestForApi(
    getRefreshGlobalConfigT,
    options
  );

  const getJobTriggerT: ReplaceRequestParams<
    GetJobTriggerT,
    RequestParams<GetJobTriggerT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getJobTriggerDefaultDecoder(),
    url: ({ ["jobtype"]: jobtype }) => `${basePath}/refresh/job/${jobtype}`,

    query: () => withoutUndefinedValues({})
  };
  const getJobTrigger: TypeofApiCall<GetJobTriggerT> = createFetchRequestForApi(
    getJobTriggerT,
    options
  );

  const getServicesT: ReplaceRequestParams<
    GetServicesT,
    RequestParams<GetServicesT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getServicesDefaultDecoder(),
    url: ({}) => `${basePath}/services`,

    query: ({
      ["limit"]: limit,
      ["page"]: page,
      ["pspcode"]: pspcode,
      ["brokerpspcode"]: brokerpspcode,
      ["channelcode"]: channelcode,
      ["paymentmethodchannel"]: paymentmethodchannel,
      ["paymenttypecode"]: paymenttypecode,
      ["pspflagftamp"]: pspflagftamp,
      ["channelapp"]: channelapp,
      ["onus"]: onus,
      ["flagio"]: flagio,
      ["flowid"]: flowid,
      ["minimumamount"]: minimumamount,
      ["maximumamount"]: maximumamount,
      ["languagecode"]: languagecode,
      ["conventionCode"]: conventionCode
    }) =>
      withoutUndefinedValues({
        ["limit"]: limit,
        ["page"]: page,
        ["pspcode"]: pspcode,
        ["brokerpspcode"]: brokerpspcode,
        ["channelcode"]: channelcode,
        ["paymentmethodchannel"]: paymentmethodchannel,
        ["paymenttypecode"]: paymenttypecode,
        ["pspflagftamp"]: pspflagftamp,
        ["channelapp"]: channelapp,
        ["onus"]: onus,
        ["flagio"]: flagio,
        ["flowid"]: flowid,
        ["minimumamount"]: minimumamount,
        ["maximumamount"]: maximumamount,
        ["languagecode"]: languagecode,
        ["conventionCode"]: conventionCode
      })
  };
  const getServices: TypeofApiCall<GetServicesT> = createFetchRequestForApi(
    getServicesT,
    options
  );

  const getStationsT: ReplaceRequestParams<
    GetStationsT,
    RequestParams<GetStationsT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getStationsDefaultDecoder(),
    url: ({}) => `${basePath}/stations`,

    query: ({
      ["limit"]: limit,
      ["page"]: page,
      ["brokercode"]: brokercode,
      ["brokerdescription"]: brokerdescription,
      ["creditorinstitutioncode"]: creditorinstitutioncode,
      ["code"]: code,
      ["ordering"]: ordering
    }) =>
      withoutUndefinedValues({
        ["limit"]: limit,
        ["page"]: page,
        ["brokercode"]: brokercode,
        ["brokerdescription"]: brokerdescription,
        ["creditorinstitutioncode"]: creditorinstitutioncode,
        ["code"]: code,
        ["ordering"]: ordering
      })
  };
  const getStations: TypeofApiCall<GetStationsT> = createFetchRequestForApi(
    getStationsT,
    options
  );

  const createStationT: ReplaceRequestParams<
    CreateStationT,
    RequestParams<CreateStationT>
  > = {
    method: "post",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: createStationDefaultDecoder(),
    url: ({}) => `${basePath}/stations`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const createStation: TypeofApiCall<CreateStationT> = createFetchRequestForApi(
    createStationT,
    options
  );

  const getStationsCSVT: ReplaceRequestParams<
    GetStationsCSVT,
    RequestParams<GetStationsCSVT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getStationsCSVDefaultDecoder(),
    url: ({}) => `${basePath}/stations/csv`,

    query: () => withoutUndefinedValues({})
  };
  const getStationsCSV: TypeofApiCall<GetStationsCSVT> = createFetchRequestForApi(
    getStationsCSVT,
    options
  );

  const deleteStationT: ReplaceRequestParams<
    DeleteStationT,
    RequestParams<DeleteStationT>
  > = {
    method: "delete",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteStationDefaultDecoder(),
    url: ({ ["stationcode"]: stationcode }) =>
      `${basePath}/stations/${stationcode}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteStation: TypeofApiCall<DeleteStationT> = createFetchRequestForApi(
    deleteStationT,
    options
  );

  const getStationT: ReplaceRequestParams<
    GetStationT,
    RequestParams<GetStationT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getStationDefaultDecoder(),
    url: ({ ["stationcode"]: stationcode }) =>
      `${basePath}/stations/${stationcode}`,

    query: () => withoutUndefinedValues({})
  };
  const getStation: TypeofApiCall<GetStationT> = createFetchRequestForApi(
    getStationT,
    options
  );

  const updateStationT: ReplaceRequestParams<
    UpdateStationT,
    RequestParams<UpdateStationT>
  > = {
    method: "put",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization,

      "Content-Type": "application/json"
    }),
    response_decoder: updateStationDefaultDecoder(),
    url: ({ ["stationcode"]: stationcode }) =>
      `${basePath}/stations/${stationcode}`,

    body: ({ ["body"]: body }) => JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const updateStation: TypeofApiCall<UpdateStationT> = createFetchRequestForApi(
    updateStationT,
    options
  );

  const getStationCreditorInstitutionsT: ReplaceRequestParams<
    GetStationCreditorInstitutionsT,
    RequestParams<GetStationCreditorInstitutionsT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getStationCreditorInstitutionsDefaultDecoder(),
    url: ({ ["stationcode"]: stationcode }) =>
      `${basePath}/stations/${stationcode}/creditorinstitutions`,

    query: ({ ["limit"]: limit, ["page"]: page, ["ciNameOrCF"]: ciNameOrCF }) =>
      withoutUndefinedValues({
        ["limit"]: limit,
        ["page"]: page,
        ["ciNameOrCF"]: ciNameOrCF
      })
  };
  const getStationCreditorInstitutions: TypeofApiCall<GetStationCreditorInstitutionsT> = createFetchRequestForApi(
    getStationCreditorInstitutionsT,
    options
  );

  const getStationCreditorInstitutionsCSVT: ReplaceRequestParams<
    GetStationCreditorInstitutionsCSVT,
    RequestParams<GetStationCreditorInstitutionsCSVT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getStationCreditorInstitutionsCSVDefaultDecoder(),
    url: ({ ["stationcode"]: stationcode }) =>
      `${basePath}/stations/${stationcode}/creditorinstitutions/csv`,

    query: () => withoutUndefinedValues({})
  };
  const getStationCreditorInstitutionsCSV: TypeofApiCall<GetStationCreditorInstitutionsCSVT> = createFetchRequestForApi(
    getStationCreditorInstitutionsCSVT,
    options
  );

  const getStationCreditorInstitutionRelationT: ReplaceRequestParams<
    GetStationCreditorInstitutionRelationT,
    RequestParams<GetStationCreditorInstitutionRelationT>
  > = {
    method: "get",

    headers: ({
      ["ApiKey"]: ApiKey,
      ["Authorization"]: Authorization
    }: {
      ApiKey: string;
      Authorization: string;
    }) => ({
      "Ocp-Apim-Subscription-Key": ApiKey,

      Authorization: Authorization
    }),
    response_decoder: getStationCreditorInstitutionRelationDefaultDecoder(),
    url: ({
      ["stationcode"]: stationcode,
      ["creditorinstitutioncode"]: creditorinstitutioncode
    }) =>
      `${basePath}/stations/${stationcode}/creditorinstitutions/${creditorinstitutioncode}`,

    query: () => withoutUndefinedValues({})
  };
  const getStationCreditorInstitutionRelation: TypeofApiCall<GetStationCreditorInstitutionRelationT> = createFetchRequestForApi(
    getStationCreditorInstitutionRelationT,
    options
  );

  return {
    manageCIStationRelationship: (withDefaults || identity)(
      manageCIStationRelationship
    ),
    massiveMigration: (withDefaults || identity)(massiveMigration),
    getBrokers: (withDefaults || identity)(getBrokers),
    createBroker: (withDefaults || identity)(createBroker),
    getAllStationsMaintenances: (withDefaults || identity)(
      getAllStationsMaintenances
    ),
    deleteBroker: (withDefaults || identity)(deleteBroker),
    getBroker: (withDefaults || identity)(getBroker),
    updateBroker: (withDefaults || identity)(updateBroker),
    getStationMaintenances: (withDefaults || identity)(getStationMaintenances),
    createStationMaintenance: (withDefaults || identity)(
      createStationMaintenance
    ),
    getBrokerMaintenancesSummary: (withDefaults || identity)(
      getBrokerMaintenancesSummary
    ),
    deleteStationMaintenance: (withDefaults || identity)(
      deleteStationMaintenance
    ),
    getStationMaintenance: (withDefaults || identity)(getStationMaintenance),
    updateStationMaintenance: (withDefaults || identity)(
      updateStationMaintenance
    ),
    getBrokersPsp: (withDefaults || identity)(getBrokersPsp),
    createBrokerPsp: (withDefaults || identity)(createBrokerPsp),
    deleteBrokerPsp: (withDefaults || identity)(deleteBrokerPsp),
    getBrokerPsp: (withDefaults || identity)(getBrokerPsp),
    updateBrokerPsp: (withDefaults || identity)(updateBrokerPsp),
    getPspBrokerPsp: (withDefaults || identity)(getPspBrokerPsp),
    getCacheVersions: (withDefaults || identity)(getCacheVersions),
    getCacheByVersion: (withDefaults || identity)(getCacheByVersion),
    getCacheId: (withDefaults || identity)(getCacheId),
    getCdis: (withDefaults || identity)(getCdis),
    createCdi: (withDefaults || identity)(createCdi),
    verifyCdi: (withDefaults || identity)(verifyCdi),
    uploadHistory_1: (withDefaults || identity)(uploadHistory_1),
    deleteCdi: (withDefaults || identity)(deleteCdi),
    getCdi: (withDefaults || identity)(getCdi),
    getCdsServices: (withDefaults || identity)(getCdsServices),
    createCdsService: (withDefaults || identity)(createCdsService),
    deleteCdsService: (withDefaults || identity)(deleteCdsService),
    getCdsService: (withDefaults || identity)(getCdsService),
    updateCdsService: (withDefaults || identity)(updateCdsService),
    getCdsSubjects: (withDefaults || identity)(getCdsSubjects),
    createCdsSubject: (withDefaults || identity)(createCdsSubject),
    deleteCdsSubject: (withDefaults || identity)(deleteCdsSubject),
    getCdsSubject: (withDefaults || identity)(getCdsSubject),
    updateCdsSubject: (withDefaults || identity)(updateCdsSubject),
    getCdsSubjectServices: (withDefaults || identity)(getCdsSubjectServices),
    createCdsSubjectService: (withDefaults || identity)(
      createCdsSubjectService
    ),
    deleteCdsSubjectService: (withDefaults || identity)(
      deleteCdsSubjectService
    ),
    getCdsSubjectService: (withDefaults || identity)(getCdsSubjectService),
    updateCdsSubjectService: (withDefaults || identity)(
      updateCdsSubjectService
    ),
    getChannels: (withDefaults || identity)(getChannels),
    createChannel: (withDefaults || identity)(createChannel),
    getChannelsCSV: (withDefaults || identity)(getChannelsCSV),
    deleteChannel: (withDefaults || identity)(deleteChannel),
    getChannel: (withDefaults || identity)(getChannel),
    updateChannel: (withDefaults || identity)(updateChannel),
    getChannelPaymentServiceProviders: (withDefaults || identity)(
      getChannelPaymentServiceProviders
    ),
    getChannelPaymentServiceProvidersCSV: (withDefaults || identity)(
      getChannelPaymentServiceProvidersCSV
    ),
    getChannelPaymentTypes: (withDefaults || identity)(getChannelPaymentTypes),
    createChannelPaymentType: (withDefaults || identity)(
      createChannelPaymentType
    ),
    deleteChannelPaymentType: (withDefaults || identity)(
      deleteChannelPaymentType
    ),
    getFtpServers: (withDefaults || identity)(getFtpServers),
    createFtpServer: (withDefaults || identity)(createFtpServer),
    deleteFtpServer: (withDefaults || identity)(deleteFtpServer),
    getFtpServer: (withDefaults || identity)(getFtpServer),
    updateFtpServer: (withDefaults || identity)(updateFtpServer),
    getConfigurationKeys: (withDefaults || identity)(getConfigurationKeys),
    createConfigurationKey: (withDefaults || identity)(createConfigurationKey),
    deleteConfigurationKey: (withDefaults || identity)(deleteConfigurationKey),
    getConfigurationKey: (withDefaults || identity)(getConfigurationKey),
    updateConfigurationKey: (withDefaults || identity)(updateConfigurationKey),
    getPaymentTypes: (withDefaults || identity)(getPaymentTypes),
    createPaymentType: (withDefaults || identity)(createPaymentType),
    uploadHistory: (withDefaults || identity)(uploadHistory),
    deletePaymentType: (withDefaults || identity)(deletePaymentType),
    getPaymentType: (withDefaults || identity)(getPaymentType),
    updatePaymentType: (withDefaults || identity)(updatePaymentType),
    getPdds: (withDefaults || identity)(getPdds),
    createPdd: (withDefaults || identity)(createPdd),
    deletePdd: (withDefaults || identity)(deletePdd),
    getPdd: (withDefaults || identity)(getPdd),
    updatePdd: (withDefaults || identity)(updatePdd),
    getWfespPlugins: (withDefaults || identity)(getWfespPlugins),
    createWfespPlugin: (withDefaults || identity)(createWfespPlugin),
    deleteWfespPlugin: (withDefaults || identity)(deleteWfespPlugin),
    getWfespPlugin: (withDefaults || identity)(getWfespPlugin),
    updateWfespPlugin: (withDefaults || identity)(updateWfespPlugin),
    getCounterpartTables: (withDefaults || identity)(getCounterpartTables),
    createCounterpartTable: (withDefaults || identity)(createCounterpartTable),
    deleteCounterpartTable: (withDefaults || identity)(deleteCounterpartTable),
    getCounterpartTable: (withDefaults || identity)(getCounterpartTable),
    getCreditorInstitutions: (withDefaults || identity)(
      getCreditorInstitutions
    ),
    createCreditorInstitution: (withDefaults || identity)(
      createCreditorInstitution
    ),
    massiveUploadCbillCsv: (withDefaults || identity)(massiveUploadCbillCsv),
    massiveCreateIbans: (withDefaults || identity)(massiveCreateIbans),
    massiveCreateIbansCsv: (withDefaults || identity)(massiveCreateIbansCsv),
    upsertIbanLabel: (withDefaults || identity)(upsertIbanLabel),
    getCreditorInstitutionsView: (withDefaults || identity)(
      getCreditorInstitutionsView
    ),
    deleteCreditorInstitution: (withDefaults || identity)(
      deleteCreditorInstitution
    ),
    getCreditorInstitution: (withDefaults || identity)(getCreditorInstitution),
    updateCreditorInstitution: (withDefaults || identity)(
      updateCreditorInstitution
    ),
    getCreditorInstitutionEncodings: (withDefaults || identity)(
      getCreditorInstitutionEncodings
    ),
    createCreditorInstitutionEncoding: (withDefaults || identity)(
      createCreditorInstitutionEncoding
    ),
    deleteCreditorInstitutionEncoding: (withDefaults || identity)(
      deleteCreditorInstitutionEncoding
    ),
    getCreditorInstitutionsIbans: (withDefaults || identity)(
      getCreditorInstitutionsIbans
    ),
    createCreditorInstitutionsIbans: (withDefaults || identity)(
      createCreditorInstitutionsIbans
    ),
    getIbans: (withDefaults || identity)(getIbans),
    updateCreditorInstitutionsIbans: (withDefaults || identity)(
      updateCreditorInstitutionsIbans
    ),
    deleteCreditorInstitutionsIban: (withDefaults || identity)(
      deleteCreditorInstitutionsIban
    ),
    getCreditorInstitutionStations: (withDefaults || identity)(
      getCreditorInstitutionStations
    ),
    createCreditorInstitutionStation: (withDefaults || identity)(
      createCreditorInstitutionStation
    ),
    deleteCreditorInstitutionStation: (withDefaults || identity)(
      deleteCreditorInstitutionStation
    ),
    updateCreditorInstitutionStation: (withDefaults || identity)(
      updateCreditorInstitutionStation
    ),
    getCreditorInstitutionByPostalEncoding: (withDefaults || identity)(
      getCreditorInstitutionByPostalEncoding
    ),
    getCreditorInstitutionsByIban: (withDefaults || identity)(
      getCreditorInstitutionsByIban
    ),
    getIcas: (withDefaults || identity)(getIcas),
    createIca: (withDefaults || identity)(createIca),
    verifyIca: (withDefaults || identity)(verifyIca),
    massiveVerifyIcas: (withDefaults || identity)(massiveVerifyIcas),
    massiveCreateIcas: (withDefaults || identity)(massiveCreateIcas),
    checkXSD: (withDefaults || identity)(checkXSD),
    deleteIca: (withDefaults || identity)(deleteIca),
    getIca: (withDefaults || identity)(getIca),
    healthCheck: (withDefaults || identity)(healthCheck),
    getPaymentServiceProviders: (withDefaults || identity)(
      getPaymentServiceProviders
    ),
    createPaymentServiceProvider: (withDefaults || identity)(
      createPaymentServiceProvider
    ),
    getPaymentServiceProvidersView: (withDefaults || identity)(
      getPaymentServiceProvidersView
    ),
    deletePaymentServiceProvider: (withDefaults || identity)(
      deletePaymentServiceProvider
    ),
    getPaymentServiceProvider: (withDefaults || identity)(
      getPaymentServiceProvider
    ),
    updatePaymentServiceProvider: (withDefaults || identity)(
      updatePaymentServiceProvider
    ),
    getPaymentServiceProvidersChannels: (withDefaults || identity)(
      getPaymentServiceProvidersChannels
    ),
    createPaymentServiceProvidersChannels: (withDefaults || identity)(
      createPaymentServiceProvidersChannels
    ),
    deletePaymentServiceProvidersChannels: (withDefaults || identity)(
      deletePaymentServiceProvidersChannels
    ),
    updatePaymentServiceProvidersChannels: (withDefaults || identity)(
      updatePaymentServiceProvidersChannels
    ),
    getRefreshGlobalConfig: (withDefaults || identity)(getRefreshGlobalConfig),
    getJobTrigger: (withDefaults || identity)(getJobTrigger),
    getServices: (withDefaults || identity)(getServices),
    getStations: (withDefaults || identity)(getStations),
    createStation: (withDefaults || identity)(createStation),
    getStationsCSV: (withDefaults || identity)(getStationsCSV),
    deleteStation: (withDefaults || identity)(deleteStation),
    getStation: (withDefaults || identity)(getStation),
    updateStation: (withDefaults || identity)(updateStation),
    getStationCreditorInstitutions: (withDefaults || identity)(
      getStationCreditorInstitutions
    ),
    getStationCreditorInstitutionsCSV: (withDefaults || identity)(
      getStationCreditorInstitutionsCSV
    ),
    getStationCreditorInstitutionRelation: (withDefaults || identity)(
      getStationCreditorInstitutionRelation
    )
  };
}
